webpackJsonp([1],{

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tippy__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_tippy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_dragged__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_dragged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_dragged__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_i18n__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__labels_labels__ = __webpack_require__(555);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_tippy___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_v_dragged___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('MdSelect', __WEBPACK_IMPORTED_MODULE_0_vue__["default"].options.components.MdSelect.extend({
  methods: {
    isInvalidValue: function isInvalidValue() {
      return this.$el.validity ? this.$el.validity.badInput : this.$el.querySelector('input').validity.badInput;
    }
  }
}));

var userLang = navigator.language || navigator.userLanguage;

var i18n = new __WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]({
  locale: userLang === 'fr' ? 'fr' : 'en',
  messages: __WEBPACK_IMPORTED_MODULE_6__labels_labels__["a" /* default */]
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({ i18n: i18n, render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  } }).$mount('#app');
/* harmony default export */ __webpack_exports__["default"] = (i18n);

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Form_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormAvatar_vue__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Outlook_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Title_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Instructions_vue__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Error_vue__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eventBus__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(60);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    ESTitle: __WEBPACK_IMPORTED_MODULE_3__components_Title_vue__["a" /* default */],
    ESForm: __WEBPACK_IMPORTED_MODULE_0__components_Form_vue__["a" /* default */],
    FormAvatar: __WEBPACK_IMPORTED_MODULE_1__components_FormAvatar_vue__["a" /* default */],
    ESOutlook: __WEBPACK_IMPORTED_MODULE_2__components_Outlook_vue__["a" /* default */],
    ESInstructions: __WEBPACK_IMPORTED_MODULE_4__components_Instructions_vue__["a" /* default */],
    ESError: __WEBPACK_IMPORTED_MODULE_5__components_Error_vue__["a" /* default */]
  },
  data: function data() {
    return {
      headerGet: __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].findGetParameter('header') && String(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].findGetParameter('header')) === 'false',
      avatarGet: __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].findGetParameter('avatar') && String(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].findGetParameter('avatar')) === 'true',
      active: __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].findGetParameter('active') && String(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].findGetParameter('active')) === 'avatar' ? 'avatar' : 'email'
    };
  },
  mounted: function mounted() {
    var userLang = navigator.language || navigator.userLanguage;
    var locale = userLang === 'fr' ? 'fr' : 'en';
    if (locale === 'en') {
      var lang = document.querySelector('.lang');
      lang.classList.remove('lang--fr');
    }

    if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest = function closest(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s);
        var i = void 0;
        var el = this;
        do {
          i = matches.length;
          while (--i >= 0 && matches.item(i) !== el) {}
        } while (i < 0 && (el = el.parentElement));
        return el;
      };
    }
  },
  methods: {
    goNext: function goNext() {
      var panelLeft = document.querySelector('.panels__side--left');
      var panelRight = document.querySelector('.panels__side--right');
      panelRight.classList.toggle('panels__side--right-active');
      panelLeft.classList.toggle('panels__side--left-hidden');
    },
    changeLang: function changeLang(e) {
      var lang = document.querySelector('.lang');
      if (lang.classList.contains('lang--fr')) {
        __WEBPACK_IMPORTED_MODULE_6__main__["default"].locale = 'en';
      } else {
        __WEBPACK_IMPORTED_MODULE_6__main__["default"].locale = 'fr';
      }
      lang.classList.toggle('lang--fr');
      __WEBPACK_IMPORTED_MODULE_7__eventBus__["a" /* default */].$emit('changeLanguage', __WEBPACK_IMPORTED_MODULE_6__main__["default"].locale);
      __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].generateTag('navigation-switch-lang', 'click', __WEBPACK_IMPORTED_MODULE_6__main__["default"].locale);
    }
  }
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material_dist_vue_material_min_css__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popin_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TelInput_TelInput_vue__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eventBus__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__labels_offices__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__labels_accolades__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__labels_pslogolist__ = __webpack_require__(197);















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ESForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      form: {
        name: '',
        lastname: '',
        job: '',
        pronouns: ''
      },
      donate: null,
      office: '',
      offices: __WEBPACK_IMPORTED_MODULE_8__labels_offices__["a" /* default */],
      accolade: [],
      accolades: __WEBPACK_IMPORTED_MODULE_9__labels_accolades__["a" /* default */],
      pslogo: 'PS_Brand',
      pslogos: __WEBPACK_IMPORTED_MODULE_10__labels_pslogolist__["a" /* default */],
      mobile: '',
      formattedMobile: '',
      phone: '',
      formattedPhone: ''
    };
  },
  validations: {
    form: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["minLength"])(1)
      },
      job: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["minLength"])(1)
      },
      lastname: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["minLength"])(1)
      }
    },
    office: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  components: {
    ESPopin: __WEBPACK_IMPORTED_MODULE_2__Popin_vue__["a" /* default */],
    TelInput: __WEBPACK_IMPORTED_MODULE_3__TelInput_TelInput_vue__["a" /* default */]
  },
  computed: {
    officeIsoCode: function officeIsoCode() {
      if (__WEBPACK_IMPORTED_MODULE_8__labels_offices__["a" /* default */][this.office] && __WEBPACK_IMPORTED_MODULE_8__labels_offices__["a" /* default */][this.office].iso) {
        return __WEBPACK_IMPORTED_MODULE_8__labels_offices__["a" /* default */][this.office].iso.toUpperCase();
      }
      return '';
    },
    officeAccolades: function officeAccolades() {
      if (this.office && (this.offices[this.office].accolades || []).length > 0) {
        var filteredAccolades = {};
        for (var key in this.accolades) {
          if (this.offices[this.office].accolades.includes(key)) {
            filteredAccolades[key] = this.accolades[key];
          }
        }
        return filteredAccolades;
      }
      return {};
    }
  },
  watch: {
    office: function office(event) {
      __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$emit('changeOffice', event);
    },
    pslogo: function pslogo(event) {
      __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$emit('changePSlogo', event);
    },
    accolade: function accolade(event) {
      __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$emit('changeAccolade', event);
    },
    animated: function animated(event) {
      __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$emit('changeAnimated', event);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$on('validateForm', this.validateForm);
    __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$on('changeIcon', this.onchangeIcon);
    __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$on('changeIcon', this.onchangeIcon);
    __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$on('changeLanguage', this.changeLanguage);

    var select = document.querySelector('.md-select input');
    select.style.paddingLeft = '15px';
    select.style.fontSize = '0.875rem';

    if (false) this.populateFrom();
  },
  methods: {
    integrate: function integrate() {
      __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$emit('validateForm');
      __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].generateTag('navigation-step1', 'click');
    },
    changeLanguage: function changeLanguage() {
      this.$nextTick(function () {
        this.accolade = [];
      });
    },
    phoneUpdated: function phoneUpdated(name, formatted, payload) {
      this[name] = payload.tel;
      this.sendData(name);

      this[formatted] = payload.intl;
      this.sendData(formatted);
    },
    sendData: function sendData(name) {
      this.saveForm();
      __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$emit('changeInput', this[name] || this.form[name], name);
    },
    sendOffice: function sendOffice() {
      this.$nextTick(function () {
        this.sendData('office');
      });
    },
    sendPSLogo: function sendPSLogo() {
      this.$nextTick(function () {
        this.sendData('pslogo');
      });
    },
    sendAccolade: function sendAccolade() {
      this.$nextTick(function () {
        this.sendData('accolade');
      });
    },
    validateForm: function validateForm() {
      this.$v.$touch();
      this.saveForm();
      if (!this.$v.$invalid) {
        __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$emit('formValidated');
      }
    },

    onchangeIcon: function onchangeIcon(obj) {
      this.icons[obj.id] = obj.name.replace('_', '-');
    },
    getValidationClass: function getValidationClass(fieldName) {
      var field = this.$v.form[fieldName] || this.$v[fieldName] || this.$v.icons[fieldName];
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        };
      }
    },
    clickColor: function clickColor(index) {
      if (index !== this.colors) {
        this.colors = index;
        __WEBPACK_IMPORTED_MODULE_6__eventBus__["a" /* default */].$emit('changeColors', index - 1);
      }
    },
    clearForm: function clearForm() {
      this.$v.$reset();
      this.form.name = null;
      this.form.lastname = null;
      this.form.job = null;
      this.form.donate = null;
    },
    populateFrom: function populateFrom() {
      var storageData = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].formStorage('fetch');

      this.form = {
        name: storageData.name || '',
        lastname: storageData.lastname || '',
        job: storageData.job || '',
        pronouns: storageData.pronouns || ''
      };
      this.donate = storageData.donate || '';
      this.office = storageData.office || this.office;
      this.mobile = storageData.mobile || '';
      this.phone = storageData.phone || '';
    },
    saveForm: function saveForm() {
      var formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ office: this.office, mobile: this.mobile, phone: this.phone, donate: 'on' }, this.form);
      __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].formStorage('save', formData);
    }
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ESPopin',
  props: {
    title: String,
    text: String
  },
  data: function data() {
    return {
      showDialog: false
    };
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventBus__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__all_countries_js__ = __webpack_require__(508);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allCountries: __WEBPACK_IMPORTED_MODULE_2__all_countries_js__["a" /* default */],
      iso: '',
      phoneNumber: '',
      formattedNumberInternational: '',
      open: false
    };
  },

  props: {
    name: String,
    disabled: Boolean,
    label: String,
    defaultIso: String,
    defaultValue: String
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.defaultIso) {
        this.iso = this.defaultIso;
        if (!this.phoneNumber) {
          this.$nextTick(function () {
            this.phoneNumber = this.defaultValue;
          });
        }
      }
    });
  },

  watch: {
    phoneNumber: function phoneNumber(value) {
      this.format(value);
    },
    defaultIso: function defaultIso(value) {
      this.choose(value);
    }
  },
  computed: {
    isoClass: function isoClass() {
      return this.iso.toLowerCase();
    },
    dialCode: function dialCode() {
      var _this = this;

      if (this.iso) {
        return '+' + this.allCountries.find(function (ele) {
          return ele.iso2.toUpperCase() === _this.iso;
        }).dialCode;
      }
      return '';
    }
  },
  methods: {
    onlyNumber: function onlyNumber($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 43) {
        $event.preventDefault();
      }
    },
    choose: function choose(iso) {
      this.iso = iso;

      this.format(new __WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["a" /* AsYouType */](iso).input(this.phoneNumber));
    },
    openSelect: function openSelect() {
      this.open = !this.open;
    },
    format: function format(value) {
      var valueToFormat = value;
      if (this.phoneNumber[0] === '0') {
        valueToFormat = valueToFormat.substr(1);
      }
      if (this.phoneNumber && this.phoneNumber[0] === '+') {
        var formatter = Object(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["c" /* parseNumber */])(this.phoneNumber);
        var findCountry = this.allCountries.find(function (ele) {
          return ele.iso2.toUpperCase() === formatter.country;
        }) || this.iso;
        this.iso = findCountry.iso2 ? findCountry.iso2 : this.iso;
      }
      this.formattedNumberInternational = Object(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["b" /* formatNumber */])(valueToFormat, this.iso, 'International');
      this.$emit('update:phone', { tel: this.phoneNumber, intl: this.formattedNumberInternational });
      return new __WEBPACK_IMPORTED_MODULE_0_libphonenumber_js__["a" /* AsYouType */](this.iso).input(value);
    }
  }
});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__disclaimers__ = __webpack_require__(535);


var allAccolades = ['consulting_reports_top_50_consulting_firms', 'forbes_worlds_best_management_consulting_firms', 'HFS_generative_enterprise_services_market_leader_2023', 'idc_marketScape_for_worldwide_experience_design_2023_24', 'e_footprint', 'google_cloud_partner_of_the_year_2024', 'VivaTech_2024', 'disability_confident_employer', 'guide_to_next', 'consulting_magazine_best_firms_to_work_for_2023', 'Consultancy_uk_Top_Consulting_Firms_in_UK_2023', 'consulting_report_top_consulting_firm_2023', 'carbon_markets', 'get_ahead_cp', 'seize_the_space_t_h', 'vault_emea', 'vault_north_america', 'vault_apac', 'workingwithcancer', 'great_place_to_work_germany', 'great_place_to_work_us', 'iDBT', 'consulting_magazine_best_firms', 'school_of_next', 'forbes_best_consulting_firms', 'egalite', 'shopper_first_retail', 'uk_financial_times', 'human_rights_campaign', 'energy_tech_awards', 'tech_women', 'enable', 'gartner_peer_insights', 'idc_marketscape_2', 'gartner_topscorercx', 'gartner_magic_quadrant', 'vault_top_ranked_internship_program_2025', 'vault_top_ranked_internship_program_lgbtq_2025', 'wiwo_best_of_consulting_award_2024', 'VivaTech_2025'];

var indiaAccolades = ['consulting_reports_top_50_consulting_firms', 'forbes_worlds_best_management_consulting_firms', 'HFS_generative_enterprise_services_market_leader_2023', 'idc_marketScape_for_worldwide_experience_design_2023_24', 'e_footprint', 'google_cloud_partner_of_the_year_2024', 'VivaTech_2024', 'business_disability_forum_member', 'guide_to_next', 'consulting_magazine_best_firms_to_work_for_2023', 'Consultancy_uk_Top_Consulting_Firms_in_UK_2023', 'consulting_report_top_consulting_firm_2023', 'carbon_markets', 'get_ahead_cp', 'seize_the_space_t_h', 'vault_emea', 'vault_north_america', 'vault_apac', 'workingwithcancer', 'great_place_to_work_germany', 'great_place_to_work_us', 'iDBT', 'consulting_magazine_best_firms', 'school_of_next', 'forbes_best_consulting_firms', 'egalite', 'shopper_first_retail', 'uk_financial_times', 'human_rights_campaign', 'energy_tech_awards', 'tech_women', 'certified_great_place', 'enable', 'gartner_peer_insights', 'idc_marketscape_2', 'gartner_topscorercx', 'gartner_magic_quadrant', 'vault_top_ranked_internship_program_2025', 'vault_top_ranked_internship_program_lgbtq_2025', 'wiwo_best_of_consulting_award_2024', 'VivaTech_2025'];

var germanyAccolades = ['consulting_reports_top_50_consulting_firms', 'forbes_worlds_best_management_consulting_firms', 'HFS_generative_enterprise_services_market_leader_2023', 'idc_marketScape_for_worldwide_experience_design_2023_24', 'e_footprint', 'google_cloud_partner_of_the_year_2024', 'VivaTech_2024', 'business_disability_forum_member', 'guide_to_next', 'consulting_magazine_best_firms_to_work_for_2023', 'Consultancy_uk_Top_Consulting_Firms_in_UK_2023', 'consulting_report_top_consulting_firm_2023', 'carbon_markets', 'get_ahead_cp', 'seize_the_space_t_h', 'vault_emea', 'vault_north_america', 'vault_apac', 'workingwithcancer', 'great_place_to_work_germany', 'great_place_to_work_us', 'iDBT', 'consulting_magazine_best_firms', 'school_of_next', 'forbes_best_consulting_firms', 'egalite', 'shopper_first_retail', 'uk_financial_times', 'human_rights_campaign', 'energy_tech_awards', 'tech_women', 'gptw_germany', 'enable', 'gartner_peer_insights', 'idc_marketscape_2', 'gartner_topscorercx', 'gartner_magic_quadrant', 'vault_top_ranked_internship_program_2025', 'vault_top_ranked_internship_program_lgbtq_2025', 'wiwo_best_of_consulting_award_2024', 'VivaTech_2025'];

var officeLabels = {
  'atlanta': {
    iso: 'us',
    location: 'Atlanta',
    address: '384 Northyards, Suite 210<br/>Atlanta, GA 30313',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'beijing': {
    iso: 'cn',
    location: 'Beijing',
    address: 'Tower B-1503 & 04, Lei Shing Hong Plaza<br/>No. 8 Wangjing Street, Chaoyang District<br/>Beijing, China 100102',
    accolades: allAccolades
  },
  'belgrade': {
    iso: 'rs',
    location: 'Belgrade ',
    address: 'Bulevar Zorana Đinđića 144 A <br> Beograd 11000, Serbia',
    accolades: allAccolades
  },
  'bengaluru': {
    iso: 'in',
    location: 'Bengaluru',
    address: '2870, Building - Virgo<br/>Bagmane Constellation Business Park<br/>Outer Ring Road, Doddanekundi Circle<br/>Marathahalli Post Bengaluru<br/>560037 Karnataka, India',
    accolades: indiaAccolades
  },
  'berlin': {
    iso: 'de',
    location: 'Berlin',
    address: 'Sapient GmbH<br/> Leibnizstraße 65<br/>10629 Berlin, Germany',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].germany,
    accolades: germanyAccolades
  },
  'bogota': {
    iso: 'CO',
    location: 'Bogota',
    address: 'Calle 93b No.13-44.<br/>Bogota 110221, Colombia<br/>Tel: +57 6017449080',
    accolades: allAccolades

  },
  'boston': {
    iso: 'us',
    location: 'Boston',
    address: '40 Water Street<br/>Boston, MA 02109',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'brasov': {
    iso: 'ro',
    location: 'Brasov',
    address: 'Coresi Business Camp,<br/>5 Turnului street,<br/>N2 Office,<br/>Brașov 500152',
    accolades: allAccolades
  },
  'bucharest': {
    iso: 'ro',
    location: 'Bucharest',
    address: 'Victoriei Square, 47-53 Lascar Catargiu,<br/>Europe House, 7th floor, 010665 Bucharest<br/>Phone: +40 746 540 029',
    accolades: allAccolades
  },
  'calgary': {
    iso: 'us',
    location: 'Calgary',
    address: '700 2nd Street SW, Suite 2340<br/>Calgary, Alberta T2P 2W1, Canada',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'cape-town': {
    iso: 'za',
    location: 'Cape Town',
    address: '5th Floor, The Harrington<br/>50 Harrington St, District Six<br/>Cape Town, 7925',
    accolades: allAccolades
  },
  'chennai': {
    iso: 'in',
    location: 'Chennai',
    address: 'COWRKS India Pvt Ltd, 5th Floor,<br/>Campus 3B Millenia Business Park,<br/>Phase 2, MGR Main Rd,<br/>Kandhanchavadi, Perungudi,<br/>Tamil Nadu 600096<br/>Chennai, India',
    accolades: indiaAccolades
  },
  'chicago': {
    iso: 'us',
    location: 'Chicago',
    address: '35 W Wacker Drive<br/>Chicago, IL 60601',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'cleveland': {
    iso: 'us',
    location: 'Cleveland',
    address: '629 Euclid Avenue, 15th Floor<br/>Cleveland, OH 44114',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'cologne': {
    iso: 'de',
    location: 'Cologne',
    address: 'Sapient GmbH<br/>Cäcilienkloster 2<br/>50676 Köln, Germany',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].germany,
    accolades: germanyAccolades
  },
  'copenhagen': {
    iso: 'dk',
    location: 'Copenhagen',
    address: 'Vermundsgade 40A<br/>2100 Copenhagen, Denmark',
    accolades: allAccolades
  },
  'denver': {
    iso: 'us',
    location: 'Denver',
    address: '11030 Circle Point Road<br/>Westminster, CO 80020',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'detroit': {
    iso: 'us',
    location: 'Detroit',
    address: '135 N. Old Woodward Avenue<br/>Birmingham, MI 48009',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'dubai': {
    iso: 'ae',
    location: 'Dubai',
    address: 'DMC Building 2<br/>Office 101 First Floor<br/>Dubai Media City<br/>Dubai, UAE',
    accolades: allAccolades
  },
  'dusseldorf': {
    iso: 'de',
    location: 'Dusseldorf',
    address: 'Sapient GmbH<br/>Toulouser Allee 1<br/>40211 Düsseldorf, Germany',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].germany,
    accolades: germanyAccolades
  },
  'frankfurt': {
    iso: 'de',
    location: 'Frankfurt',
    address: 'Sapient GmbH<br/>Otto-Messmer-Straße 1<br/>60314 Frankfurt, Germany',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].germany,
    accolades: germanyAccolades
  },
  'gothenburg': {
    iso: 'se',
    location: 'Gothenburg',
    address: 'Kaserntorget 5, 411 18 Gothenburg, Sweden',
    accolades: allAccolades
  },
  'gurgaon-unit-1': {
    iso: 'in',
    location: 'Gurgaon (Infospace Unit 1)',
    address: 'Candor Techspace, Tower-A<br/>Building no. 2, Sector 21<br/>Old Delhi-Gurgaon Road<br/>Dundahera, Gurgaon - 122016 Haryana, India',
    accolades: indiaAccolades
  },
  'gurgaon-unit-3': {
    iso: 'in',
    location: 'Gurgaon (Infospace Unit 3)',
    address: 'Candor Techspace, Tower-B<br/>Building no. 8, Ground to 9th Floor, Sector 21<br/>Old Delhi - Gurgaon Road<br/>Dundahera, Gurgaon – 122016, Haryana, India',
    accolades: indiaAccolades
  },
  'gurgaon-unit-4': {
    iso: 'in',
    location: 'Gurgaon (Infospace Unit 4)',
    address: 'Candor Techspace, Tower-B<br/>Building no. 6, 6th to 9th Floor, Sector 21<br/>Old Delhi - Gurgaon Road<br/>Dundahera, Gurgaon – 122016, Haryana, India',
    accolades: indiaAccolades
  },
  'hamburg': {
    iso: 'de',
    location: 'Hamburg',
    address: 'Sapient GmbH<br/>Heidi-Kabel-Platz 2<br/>20099 Hamburg, Germany',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].germany,
    accolades: germanyAccolades
  },
  'heredia': {
    iso: 'CR',
    location: 'Heredia',
    address: 'Eurocenter Building II, Third Floor.<br/>Heredia, Barreal, PO 40101<br/>Tel: +506 22098200',
    accolades: allAccolades
  },
  'hong-kong': {
    iso: 'hk',
    location: 'Hong Kong',
    address: '6F AIA Kowloon Tower<br/>100 How Ming St<br/>Kwun Tong, Hong Kong',
    accolades: allAccolades
  },
  'houston': {
    iso: 'us',
    location: 'Houston',
    address: '1111 Bagby St<br/>Suite 1950<br/>Houston, TX 77002',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'hyderabad': {
    iso: 'in',
    location: 'Hyderabad',
    address: 'Plot No 5 and 6, Block 4,<br/>5th Floor, Divya Sree Trinity,<br/>Hi-Tech City Layout, Madhapur,<br/>Hyderabad - 500081 , Telangana, India',
    accolades: indiaAccolades
  },
  'iasi': {
    iso: 'ro',
    location: 'Iasi',
    address: 'Fab Lab,<br/>Strada Morilor 56,<br/>Iași 700011',
    accolades: allAccolades
  },
  'irving': {
    iso: 'us',
    location: 'Irving',
    address: '6021 Connection Dr,<br/>Irving, TX 75039',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'johannesburg': {
    iso: 'za',
    location: 'Johannesburg',
    address: 'Building 1, Silver Stream Office Park<br/>10 Muswell Rd<br/>2194 Johannesburg',
    accolades: allAccolades
  },
  'kolkata': {
    iso: 'in',
    location: 'Kolkata',
    address: '6th Floor, Street No. 13,<br/>DP Block, Sector V, Bidhannagar,<br/>Kolkata, West Bengal 700091, India',
    accolades: indiaAccolades
  },
  'london': {
    iso: 'gb',
    location: 'London',
    address: 'Turnmill<br/>63 Turnmill Street<br />London, EC1M 5RR',
    accolades: allAccolades
  },
  'los-angeles': {
    iso: 'us',
    location: 'Los Angeles',
    address: '13031 W Jefferson Blvd #800<br/>Los Angeles, CA 90094',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'malmo': {
    iso: 'se',
    location: 'Malmö',
    address: 'Brogatan 10<br/>211 44 Malmö, Sweden',
    accolades: allAccolades
  },
  'melbourne': {
    iso: 'au',
    location: 'Melbourne',
    address: 'Level 7, 28 Freshwater Place<br/>Southbank, VIC 3006',
    accolades: allAccolades
  },
  'méxico-city': {
    iso: 'MX',
    location: ' México City',
    address: 'Bosque de Duraznos 65,<br/>Bosque de las Lomas, Miguel Hidalgo,<br/>11700 Ciudad de México<br/>Tel: +52 55 9177 5600',
    accolades: allAccolades
  },
  'miami-coconut-grove': {
    iso: 'us',
    location: 'Miami - Coconut Grove',
    address: '2911 Grand Avenue, Suite 100B<br/>Miami, FL 33133',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'miami-community': {
    iso: 'us',
    location: 'Miami - the community',
    address: '6400 Biscayne Blvd.<br/>Miami, FL 33138',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'milan': {
    iso: 'it',
    location: 'Milan',
    address: 'Via Bernina 34<br/>20158 Milano, Italy',
    accolades: allAccolades
  },
  'mumbai': {
    iso: 'in',
    location: 'Mumbai',
    address: 'R-Tech Park, Goregaon(E)<br/>13th Floor, Building 2<br/>Off Western Express Highway<br/>Mumbai, Maharashtra - 400063, India',
    accolades: indiaAccolades
  },
  'munich': {
    iso: 'de',
    location: 'Munich',
    address: 'Sapient GmbH<br/>Arnulfstraße 60<br/>80335 München, Germany',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].germany,
    accolades: germanyAccolades
  },
  'minneapolis': {
    iso: 'us',
    location: 'Minneapolis',
    address: '901 Marquette Ave, Floor 24<br/>Minneapolis, MN 55402 ',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'nancy': {
    iso: 'fr',
    location: 'Nancy',
    address: '14 Rue François de Neufchâteau<br/>54000 Nancy, France',
    accolades: allAccolades
  },
  'new-york': {
    iso: 'us',
    location: 'New York',
    address: '375 Hudson Street, 9th Floor<br/>New York, NY 10014',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'noida': {
    iso: 'in',
    location: 'Noida',
    address: 'Tower C, Ground Floor to 4th Floor<br/>IT/ ITES SEZ, Plot No. 7, Sector -144, Noida, Distt. G. B. Nagar (U.P.), India',
    accolades: indiaAccolades
  },
  'noida-candor': {
    iso: 'in',
    location: 'Noida Candor',
    address: '12th Floor, Candor Tech Space, Building No. 5<br/>IT / ITES SEZ, Seaview Developers Pvt. Ltd.<br/>Plot No. 20 & 21, Sector -135, Noida, India',
    accolades: indiaAccolades
  },
  'oman': {
    iso: 'om',
    location: 'Oman',
    address: 'Publicis Muscat SPC<br/>7th Floor, Al Fardan Building<br/>724-56 Ghala Heights<br/>Muscat, Sultanate of Oman',
    accolades: allAccolades
  },
  'paris': {
    iso: 'fr',
    location: 'Paris',
    address: '145 rue de Courcelles<br/>75017 Paris, France',
    accolades: allAccolades
  },
  'portland': {
    iso: 'us',
    location: 'Portland',
    address: '1330 NW 14th Avenue<br/>Portland, OR 97209',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'riyadh': {
    iso: 'sa',
    location: 'Riyadh',
    address: 'Faisaliah Tower, 9th floor<br/>Riyadh 11351, P.O. Box 295797,<br/>Olaya Road, KSA',
    accolades: allAccolades
  },
  'san-francisco': {
    iso: 'us',
    location: 'San Francisco',
    address: '350 Bush Street, Floor 17<br/>San Francisco, CA 94104',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'san-jose': {
    iso: 'us',
    location: 'San Jose',
    address: '1 Almaden Avenue, Suite 650<br/>San Jose, CA 95113',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'san-luis-obispo': {
    iso: 'us',
    location: 'San Luis Obispo',
    address: '4800 Morabito Place<br/>San Luis Obispo, CA 93401',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'seattle': {
    iso: 'us',
    location: 'Seattle',
    address: '424 2nd Avenue West<br/>Seattle, WA 98119',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'shanghai': {
    iso: 'cn',
    location: 'Shanghai',
    address: '19/F, Henderson 688 Plaza<br/>No. 688 West Nanjing Road, Jingan District<br/>Shanghai, China 200041',
    accolades: allAccolades
  },
  'singapore': {
    iso: 'sg',
    location: 'Singapore',
    address: '120 Beach Road<br/>Guoco Midtown House<br/>Level 3, Unit 01</br>Singapore 189769',
    accolades: allAccolades
  },
  'stockholm': {
    iso: 'se',
    location: 'Stockholm',
    address: 'Lumaparksvägen 7, 8tr<br/>120 31 Stockholm, Sweden',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].stockholm,
    accolades: allAccolades
  },
  'sydney': {
    iso: 'au',
    location: 'Sydney',
    address: 'Level 3, 21 Harris Street,<br/>Pyrmont,<br/>Sydney 2009 NSW, Australia',
    accolades: allAccolades
  },
  'timisoara': {
    iso: 'ro',
    location: 'Timisoara',
    address: 'Calea Aradului<br/>no.11, 3rd floor<br/>Timisoara 300254',
    accolades: allAccolades
  },
  'tokyo': {
    iso: 'jp',
    location: 'Tokyo',
    address: 'JR Tokyu Meguro Building<br/>3-1-1 Kami-Osaki, Shinagawa-ku<br/>Tokyo 141-0021, Japan',
    accolades: allAccolades
  },
  'toronto': {
    iso: 'us',
    location: 'Toronto',
    address: '134 Peter Street,12th Floor<br/>Toronto, ON M5V 2H2',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'turin': {
    iso: 'it',
    location: 'Turin',
    address: 'Via Santa Teresa, 12<br/>10121 Turin, Italy',
    accolades: allAccolades
  },
  'washington': {
    iso: 'us',
    location: 'Washington D.C. - Arlington ',
    address: '1515 North Courthouse Road, 4th Floor<br/>Arlington, VA 22201',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].usa,
    accolades: allAccolades
  },
  'zurich': {
    iso: 'ch',
    location: 'Zurich',
    address: 'Sapient Switzerland GmbH<br/>Stadelhoferstrasse 25<br/>8001 Zürich, Switzerland',
    disclaimer: __WEBPACK_IMPORTED_MODULE_0__disclaimers__["a" /* default */].zurich,
    accolades: allAccolades
  }
};

/* harmony default export */ __webpack_exports__["a"] = (officeLabels);

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var accoladesLabels = {
	'consulting_reports_top_50_consulting_firms': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/ConsultinReport-EmailSignature-2024.png',
		width: 225,
		height: 65
	},
	'forbes_worlds_best_management_consulting_firms': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Forbes-EmailSignature-2024.png',
		width: 315,
		height: 58
	},
	'HFS_generative_enterprise_services_market_leader_2023': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/HFS-Logo.png',
		width: 225,
		height: 80,
		href: 'https://www.publicissapient.com/news/2023-market-leader-in-gen-ai-enterprise-services-by-hfs'
	},
	'idc_marketScape_for_worldwide_experience_design_2023_24': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/IDC-Logo.png',
		width: 225,
		height: 80,
		href: 'https://www.publicissapient.com/news/publicis-sapient-named-a-leader-in-2023-2024-idc-marketscape'
	},
	'e_footprint': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/image-2024-05-02-17-12-08-989.png',
		width: 148,
		height: 43,
		href: 'https://publicissapient-france.github.io/e-footprint/'
	},
	'google_cloud_partner_of_the_year_2024': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/poy2024_email_signature_250x150-1.png',
		width: 250,
		height: 120,
		href: 'https://www.publicissapient.com/partnerships/google/publicis-sapient-named-partner-of-the-year-2024'
	},
	'VivaTech_2024': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Viva_sig_03_noLoop_5sec.gif',
		width: 200,
		height: 189,
		href: ' https://vivatech-2024.splashthat.com/?utm_source=outlook&utm_medium=email&utm_campaign=FR_IND_VivaTech.Email.Signature_03.2024_Other_OF.NO&utm_content=VivaTech2024_EmailSignature&utm_category=Regional.Targeting&OfferingFamily=OF.NO'
	},
	'disability_confident_employer': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/rsz_3picture4.jpg',
		width: 153.2,
		height: 62.4
	},
	'guide_to_next': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_Guide-to-Next_Signatur-2023-2x-1.png',
		width: 140,
		height: 22,
		href: 'https://guidetonext.publicissapient.com/?utm_source=outlook&utm_medium=email&utm_content=G2NEmailSignature&utm_campaign=XIND_IND_G2N.2024.Email.Signature_09.2023_Other_OF.NO&utm_category=G2N'
	},
	'consulting_magazine_best_firms_to_work_for_2023': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/ConsultingBestWork2023-Logo-Email.png',
		width: 211,
		height: 47
	},
	'Consultancy_uk_Top_Consulting_Firms_in_UK_2023': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/ConsultancyUK-TopConsultingFirmAward.png',
		width: 211,
		height: 47
	},
	'consulting_report_top_consulting_firm_2023': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Consulting-Report_Top-50-2023_Email-Signature.png',
		width: 211,
		height: 47
	},
	'carbon_markets': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Carbonmarkets-EmailSignature.png',
		width: 166,
		height: 71,
		href: 'https://www.publicissapient.com/insights/carbon-markets-videos?utm_source=outlook&utm_medium=email-signature&utm_campaign=EC_CLI_Carbon.Market.Video.Email.Signature_04.2023_Other&utm_content=EC_CLI_Carbon.Market.Video.Email.Signature_04.2023_Other_CMVLogo&utm_category=Energy.Commodities'
	},
	'get_ahead_cp': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/get-ahead-signature-new.jpg',
		width: 156,
		height: 65
	},
	'seize_the_space_t_h': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/seize-the-space-signature.jpg',
		width: 156,
		height: 65
	},
	'vault_emea': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Email_EMEA_Consulting.png',
		width: 258,
		height: 55
	},
	'vault_north_america': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Email_Consulting.png',
		width: 258,
		height: 55
	},
	'vault_apac': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Email_APAC_Consulting.png',
		width: 258,
		height: 55
	},
	'workingwithcancer': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_WWC_Signature.png',
		width: 225,
		height: 44,
		href: 'https://workingwithcancerpledge.com/'
	},
	'great_place_to_work_germany': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/GoodPlaceToWork_GermanyBadge.png',
		width: 225,
		height: 44
	},
	'great_place_to_work_us': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/GoodPlaceToWork_USABadge.png',
		width: 225,
		height: 44
	},
	'iDBT': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/iDBT.png',
		width: 156,
		height: 44
	},
	'consulting_magazine_best_firms': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Consulting_Magazine_Signature.png',
		width: 156,
		height: 44
	},
	'school_of_next': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_SchoolOfNext_Signature_NoCircle.png',
		width: 92,
		height: 44
	},
	'forbes_best_consulting_firms': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Forbes-EmailSignature-2023.png',
		width: 350,
		height: 45
	},
	'egalite': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/egalite-logo-new-1.png',
		width: 200,
		height: 40
	},
	'shopper_first_retail': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_ShopperFirstRetail_Signature%402x.png',
		width: 156,
		height: 40,
		href: 'https://www.publicissapient.com/industries/retail'
	},
	'uk_financial_times': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/2022UKFinancialTimes_EmailSignature.jpg',
		width: 334,
		height: 40
	},
	'human_rights_campaign': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/HumanRightsCampaign_EmailSignature.jpg',
		width: 339,
		height: 39
	},
	'tech_women': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/tech_women.jpg',
		width: 150,
		height: 40
	},
	'gptw_germany': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/gptw-germany.png',
		width: 185,
		height: 40
	},
	'certified_great_place': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/certified-great_place-80h.png',
		width: 237,
		height: 40
	},
	'energy_tech_awards': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_ETA_Signature.png',
		width: 70,
		height: 64,
		href: 'https://www.publicissapient.com/industries/energy-commodities/tech-awards?utm_source=outlook&utm_medium=email-signature&utm_campaign=EC_IND_Energy.Tech.Email.Signature_04.2023_Other&utm_content=EC_IND_Energy.Tech.Email.Signature_04.2023_Other_ETA2023Logo&utm_category=Energy.Commodities'
	},
	'the_how_channel': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/THC_logo.jpg',
		width: 120,
		height: 44,
		href: 'https://thehowchannel.publicissapient.com/'
	},
	'enable': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_enABLE_Signature2x-new.png',
		width: 88,
		height: 40
	},
	'gartner_peer_insights': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/GartnerPeerInisghts_EmailSignature.png',
		width: 232,
		height: 93
	},
	'idc_marketscape_2': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/IDC_Marketscape_EmailSignature.jpg',
		width: 200,
		height: 40
	},
	'gartner_topscorercx': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Gartner_TopScorerCX_EmailSignature.jpg',
		width: 200,
		height: 46
	},
	'gartner_magic_quadrant': {
		url: 'https://ps-email-signature-generator.s3.amazonaws.com/Gartner_MagicQuadrantCRMandCX_EmailSignature.jpg',
		width: 223,
		height: 48
	},

	'vault_top_ranked_internship_program_2025': {
		url: 'https://ps-email-signature-generator.s3.us-east-1.amazonaws.com/Vault_Internships_2025.png',
		width: 289,
		height: 57
	},

	'vault_top_ranked_internship_program_lgbtq_2025': {
		url: 'https://ps-email-signature-generator.s3.us-east-1.amazonaws.com/Vault_Internships_LGBTQ_2025.png',
		width: 342,
		height: 57
	},
	'VivaTech_2025': {
		url: 'https://ps-email-signature-generator.s3.us-east-1.amazonaws.com/250228_VivaTech_Box_Email-Signature_a002.gif',
		width: 200,
		height: 189
	}

};

/* harmony default export */ __webpack_exports__["a"] = (accoladesLabels);

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pslogolist = {
  'PS_Brand': {
    url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_Logo@2x.png',
    width: 56,
    height: 74
  },
  'PS_Pride': {
    url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_Logo_Pride_Retina.png',
    width: 51,
    height: 60
  }
};

/* harmony default export */ __webpack_exports__["a"] = (pslogolist);

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_range_slider__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_range_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_range_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material_dist_vue_material_min_css__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorRing__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventBus__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(60);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAvatar',
  data: function data() {
    return {
      color: '#000',

      tabsSlide: 0,

      download: null,
      downloadBg: null,
      downloadBgWide: null,
      downloadBigStroke: null,

      sliderValue: 50,
      sliderMin: 1,
      sliderMax: 101,
      sliderStep: 1,

      file: '',
      showPreview: false,
      imagePreview: '',

      dragged: false,
      dragLeft: 0,
      dragTop: 0,
      dragLeftInt: 0,
      dragTopInt: 0,

      canvas: null,
      ctx: null
    };
  },
  components: {
    ColorRing: __WEBPACK_IMPORTED_MODULE_2__ColorRing__["a" /* default */],
    RangeSlider: __WEBPACK_IMPORTED_MODULE_0_vue_range_slider___default.a
  },
  watch: {},
  computed: {
    scalePreview: function scalePreview() {
      return this.sliderValue / 50;
    }
  },
  mounted: function mounted() {
    var canvas = this.$refs.canvas;
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
  },
  methods: {
    changeSliderEnd: function changeSliderEnd(value) {
      this.drawCanvasImage();
    },
    clickTab: function clickTab(value) {
      if (value) {
        var index = parseInt(value.replace('instruction-tab-', ''), 10);
        this.tabsSlide = -index * 100;
      }
    },
    clickRange: function clickRange(value) {
      var newValue = value + this.sliderValue;
      if (newValue <= this.sliderMax && newValue >= this.sliderMin) {
        this.sliderValue = newValue;
        this.drawCanvasImage();
      }
    },
    clickColor: function clickColor(value) {
      this.color = value;
      this.drawCanvasImage();
    },
    triggerInputFile: function triggerInputFile() {
      this.$refs.file.click();
    },
    onDragged: function onDragged(_ref) {
      var el = _ref.el,
          deltaX = _ref.deltaX,
          deltaY = _ref.deltaY,
          offsetX = _ref.offsetX,
          offsetY = _ref.offsetY,
          clientX = _ref.clientX,
          clientY = _ref.clientY,
          first = _ref.first,
          last = _ref.last;

      if (first) {
        this.dragged = true;
        return;
      }
      if (last) {
        this.drawCanvasImage();
        this.dragged = false;
        return;
      }
      var l = +window.getComputedStyle(el)['left'].slice(0, -2) || 0;
      var t = +window.getComputedStyle(el)['top'].slice(0, -2) || 0;

      this.dragLeftInt = l + deltaX;
      this.dragTopInt = t + deltaY;

      this.dragLeft = this.dragLeftInt + 'px';
      this.dragTop = this.dragTopInt + 'px';
    },
    submitFile: function submitFile() {},
    handleFileUpload: function handleFileUpload() {
      this.sliderValue = 50;
      this.dragLeft = '0px';
      this.dragTop = '0px';
      this.file = this.$refs.file.files[0];
      var reader = new FileReader();

      reader.addEventListener("load", function () {
        this.showPreview = true;
        this.imagePreview = reader.result;

        this.drawCanvasImage();
      }.bind(this), false);

      if (this.file) {
        if (/\.(jpe?g|png|bmp|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    drawCanvasImageCommon: function drawCanvasImageCommon(image, strokeWidth) {

      var defaultPreviewSize = 210;
      var ratioPreview = defaultPreviewSize / this.canvas.width;

      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this.ctx.arc(this.canvas.height / 2, this.canvas.height / 2, this.canvas.height / 2 - strokeWidth, 0, Math.PI * 2, false);
      this.ctx.fillStyle = '#fff';
      this.ctx.fill();

      this.ctx.globalCompositeOperation = 'source-atop';
      this.ctx.drawImage(image, this.dragLeftInt / ratioPreview, this.dragTopInt / ratioPreview, image.width * this.scalePreview / ratioPreview, image.height * this.scalePreview / ratioPreview);
      this.ctx.globalCompositeOperation = 'source-over';

      this.ctx.beginPath();

      this.ctx.arc(this.canvas.height / 2, this.canvas.height / 2, this.canvas.height / 2 - strokeWidth, 0, Math.PI * 2, false);
      this.ctx.closePath();
      if (!/^#/.test(this.color)) {
        var gr = this.ctx.createLinearGradient(70, 70, 330, 330);
        gr.addColorStop(0, '#fa000f');
        gr.addColorStop(1 / 10, '#fa000f');
        gr.addColorStop(1 / 10, '#ffa826');
        gr.addColorStop(2 / 10, '#ffa826');
        gr.addColorStop(2 / 10, '#f0ea41');
        gr.addColorStop(3 / 10, '#f0ea41');
        gr.addColorStop(3 / 10, '#00c15e');
        gr.addColorStop(4 / 10, '#00c15e');
        gr.addColorStop(4 / 10, '#385ffa');
        gr.addColorStop(5 / 10, '#385ffa');
        gr.addColorStop(5 / 10, '#8e00e4');
        gr.addColorStop(6 / 10, '#8e00e4');
        gr.addColorStop(6 / 10, '#000000');
        gr.addColorStop(7 / 10, '#000000');
        gr.addColorStop(7 / 10, '#774f36');
        gr.addColorStop(8 / 10, '#774f36');
        gr.addColorStop(8 / 10, '#16c7d6');
        gr.addColorStop(9 / 10, '#16c7d6');
        gr.addColorStop(9 / 10, '#f787e6');
        gr.addColorStop(10 / 10, '#f787e6');
        this.ctx.strokeStyle = gr;
      } else {
        this.ctx.strokeStyle = this.color;
      }
      this.ctx.lineWidth = strokeWidth;
      this.ctx.stroke();
    },
    drawCanvasImage: function drawCanvasImage() {
      var _this = this;

      this.canvas.height = 400;
      this.canvas.width = 400;

      var strokeWidth = 20;

      var image = new Image();

      image.onload = function () {

        _this.drawCanvasImageCommon(image, strokeWidth);

        if (_this.imagePreview) {
          _this.download = _this.canvas.toDataURL('image/png');
        }

        strokeWidth = 30;
        _this.drawCanvasImageCommon(image, strokeWidth);

        if (_this.imagePreview) {
          _this.downloadBigStroke = _this.canvas.toDataURL('image/png');
        }

        strokeWidth = 20;
        _this.drawCanvasImageCommon(image, strokeWidth);
        _this.ctx.globalCompositeOperation = 'destination-over';
        _this.ctx.fillStyle = '#fff';

        _this.ctx.fillRect(0, 0, _this.canvas.width, _this.canvas.height);

        if (_this.imagePreview) {
          _this.downloadBg = _this.canvas.toDataURL('image/png');
        }
      };
      image.src = this.imagePreview;
    },
    changeCanvasSize: function changeCanvasSize(canvasResult) {
      var _this2 = this;

      this.canvas.height = 210;
      this.canvas.width = 280;

      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      var img = new Image();
      img.onload = function () {
        _this2.ctx.drawImage(img, 35, 0);

        _this2.ctx.globalCompositeOperation = 'destination-over';

        _this2.ctx.fillStyle = 'rgba(255, 255, 255, 0)';
        _this2.ctx.fillRect(0, 0, _this2.canvas.width, _this2.canvas.height);

        if (_this2.imagePreview) {
          _this2.downloadBgWide = _this2.canvas.toDataURL('image/png');
        }
      };
      img.src = canvasResult;
    }
  }
});

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ColorRing',
  props: {
    list: Array
  },
  data: function data() {
    return {
      current: null
    };
  },

  methods: {
    clickColor: function clickColor(active) {
      this.current = active;
      this.$emit('change', active);
    }
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventBus__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__labels_offices__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__labels_accolades__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__labels_pslogolist__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(60);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ESOutlook',
  data: function data() {
    return {
      name: '',
      lastname: '',
      job: '',
      pronouns: '',
      mobile: '',
      formattedMobile: '',
      phone: '',
      formattedPhone: '',
      office: '',
      offices: __WEBPACK_IMPORTED_MODULE_1__labels_offices__["a" /* default */],
      accolade: [],
      accolades: __WEBPACK_IMPORTED_MODULE_2__labels_accolades__["a" /* default */],
      pslogo: 'PS_Brand',
      pslogos: __WEBPACK_IMPORTED_MODULE_3__labels_pslogolist__["a" /* default */],
      typing: '',
      lang: 'fr',
      courtesy: this.$i18n.t('mail.courtesy'),
      index: 0,
      preview: true,
      animated: true,
      colors: 0,
      signature_url: '',
      redirect_hash: '',
      uuid: '',
      donate: this.donate,
      icons: {
        verticale: { name: 'all' },
        expertise: { name: 'business-analyst' },
        hobby: { name: 'alien' }
      }
    };
  },
  computed: {
    cleanJob: function cleanJob() {
      return encodeURIComponent(this.job);
    },
    mobile_formated: function mobile_formated() {
      return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].formatPhone(this.mobile, '+33');
    },
    phone_formated: function phone_formated() {
      return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].formatPhone(this.phone, '+33');
    },
    redirect_url: function redirect_url() {
      return 'https://www.publicissapient.com';
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('changeInput', this.onChangeInput);
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('changeOffice', this.onChangeOffice);
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('changePSlogo', this.onchangePSlogo);
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('changeAccolade', this.onChangeAccolade);
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('changeAnimated', this.onChangeAnimated);
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('changeColors', this.onChangeColors);
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('changeIcon', this.onchangeIcon);
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('changeLanguage', this.changeLanguage);
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('formValidated', this.formValidated);
    this.uuid = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getUuid();
    this.createInterval();
  },
  methods: {
    formValidated: function formValidated() {
      var panelLeft = document.querySelector('.panels__side--left');
      var panelRight = document.querySelector('.panels__side--right');
      panelRight.classList.toggle('panels__side--right-active');
      panelLeft.classList.toggle('panels__side--left-hidden');

      var buttonIntegrate = document.querySelector('.buttonIntegrate');
      buttonIntegrate.classList.toggle('active');

      this.preview = !buttonIntegrate.classList.contains('active');
      if (!this.preview) {
        var datasSignature = {
          hasMobile: this.mobile ? true : false,
          hasPhone: this.phone ? true : false,
          variables: '' + this.lang
        };

        __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].generateTag('gif-server', 'build', datasSignature.variables + '!' + this.office + '!' + datasSignature.hasMobile + '!' + datasSignature.hasPhone + '!v2');
        __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$emit('genaration-ready', true);
      }
    },
    onChangeInput: function onChangeInput(value, name) {
      this[name] = value;
    },
    onChangeOffice: function onChangeOffice(value) {
      this.office = value;
    },
    onchangePSlogo: function onchangePSlogo(value) {
      this.pslogo = value;
    },
    onChangeAccolade: function onChangeAccolade(value) {
      this.accolade = value;
    },
    onChangeAnimated: function onChangeAnimated(value) {
      this.animated = value;
    },
    onChangeColors: function onChangeColors(value) {
      this.colors = value;
    },
    onchangeIcon: function onchangeIcon(obj) {
      this.icons[obj.id] = {
        name: obj.name.replace('_', '-')
      };
    },
    changeLanguage: function changeLanguage(lang) {
      this.lang = lang;
      clearInterval(this.intervalid);
      this.courtesy = this.$i18n.t('mail.courtesy');
      this.createInterval();
    },
    createInterval: function createInterval() {
      this.intervalid = setInterval(function () {
        if (this.index > this.courtesy.length) {
          clearInterval(this.intervalid);
        }
        this.typing = this.courtesy.slice(0, this.index);
        this.index += 1;
      }.bind(this), 60);
    }
  }
});

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(60);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ESTitle',
  props: ['currentTab'],
  data: function data() {
    return {
      headerGet: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].findGetParameter('header') && String(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].findGetParameter('header')) === 'false',
      logoGet: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].findGetParameter('logo') && String(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].findGetParameter('logo')) === 'false',
      titleGet: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].findGetParameter('title') && String(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].findGetParameter('title')) === 'false',
      avatarGet: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].findGetParameter('avatar') && String(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].findGetParameter('avatar')) === 'true'
    };
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventBus__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(60);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ESInstructions',
  data: function data() {
    return {
      disabled: true,
      gaDatas: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    integrate: function integrate() {
      __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$emit('validateForm');
      __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].generateTag('navigation-step2', 'click');
    },
    copyCode: function copyCode() {
      this.selectText('outlook-signature');
      this.createTimeoutHideTippy();
    },
    selectText: function selectText(element) {
      var doc = document;
      var text = doc.getElementById(element);
      var range = void 0;
      var selection = void 0;
      if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
        document.execCommand("Copy");
        range.removeAllRanges();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand("Copy");
        selection.removeAllRanges();
      }
    },
    activateCopy: function activateCopy(ready) {
      this.disabled = !ready;
    },
    clickTabs: function clickTabs(datas) {
      __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].generateTag('navigation-instructions', 'click', datas);
    },
    clearTimer: function clearTimer() {
      if (this.timeoutid) {
        clearTimeout(this.timeoutid);
      }
    },
    createTimeoutHideTippy: function createTimeoutHideTippy() {
      var _this = this;

      this.timeoutid = setTimeout(function () {
        try {
          _this.$refs['buttonTooltip']._tippy.hide();
        } catch (error) {}
        _this.clearTimer();
      }, 1000);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('genaration-ready', this.activateCopy);

    var indicator = document.querySelector('.md-tabs-indicator');
    indicator.classList.add('tmp');
    indicator.style.backgroundColor = '#000';
  }
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventBus__ = __webpack_require__(50);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ESError',
  data: function data() {
    return {
      message: '',
      showDialog: false
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__eventBus__["a" /* default */].$on('error-message', this.errorMessage);
  },
  methods: {
    errorMessage: function errorMessage(message) {
      this.showDialog = true;
      this.message = message;
    }
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(205);
module.exports = __webpack_require__(168);


/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99bf6c34_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(550);
function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99bf6c34_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 411:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c34b2b26_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(536);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c34b2b26_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popin_vue__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7e851a_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popin_vue__ = __webpack_require__(443);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7e851a_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"question-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.showDialog = true}}},[_c('span',[_vm._v("?")])]),_vm._v(" "),_c('md-dialog',{staticClass:"popin-default",attrs:{"md-active":_vm.showDialog,"md-backdrop":true},on:{"update:mdActive":function($event){_vm.showDialog=$event},"update:md-active":function($event){_vm.showDialog=$event}}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item",domProps:{"innerHTML":_vm._s(_vm.text)}})])]),_vm._v(" "),_c('md-dialog-actions',[_c('button',{staticClass:"button",on:{"click":function($event){_vm.showDialog = false}}},[_vm._v(_vm._s(_vm.$t('popinClose')))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TelInput_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ac0826_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TelInput_vue__ = __webpack_require__(509);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TelInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ac0826_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TelInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(116);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var allCountries = [['Afghanistan (‫افغانستان‬‎)', 'af', '93'], ['Albania (Shqipëri)', 'al', '355'], ['Algeria (‫الجزائر‬‎)', 'dz', '213'], ['American Samoa', 'as', '1684'], ['Andorra', 'ad', '376'], ['Angola', 'ao', '244'], ['Anguilla', 'ai', '1264'], ['Antigua and Barbuda', 'ag', '1268'], ['Argentina', 'ar', '54'], ['Armenia (Հայաստան)', 'am', '374'], ['Aruba', 'aw', '297'], ['Australia', 'au', '61', 0], ['Austria (Österreich)', 'at', '43'], ['Azerbaijan (Azərbaycan)', 'az', '994'], ['Bahamas', 'bs', '1242'], ['Bahrain (‫البحرين‬‎)', 'bh', '973'], ['Bangladesh (বাংলাদেশ)', 'bd', '880'], ['Barbados', 'bb', '1246'], ['Belarus (Беларусь)', 'by', '375'], ['Belgium (België)', 'be', '32'], ['Belize', 'bz', '501'], ['Benin (Bénin)', 'bj', '229'], ['Bermuda', 'bm', '1441'], ['Bhutan (འབྲུག)', 'bt', '975'], ['Bolivia', 'bo', '591'], ['Bosnia and Herzegovina (Босна и Херцеговина)', 'ba', '387'], ['Botswana', 'bw', '267'], ['Brazil (Brasil)', 'br', '55'], ['British Indian Ocean Territory', 'io', '246'], ['British Virgin Islands', 'vg', '1284'], ['Brunei', 'bn', '673'], ['Bulgaria (България)', 'bg', '359'], ['Burkina Faso', 'bf', '226'], ['Burundi (Uburundi)', 'bi', '257'], ['Cambodia (កម្ពុជា)', 'kh', '855'], ['Cameroon (Cameroun)', 'cm', '237'], ['Canada', 'ca', '1', 1, ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']], ['Cape Verde (Kabu Verdi)', 'cv', '238'], ['Caribbean Netherlands', 'bq', '599', 1], ['Cayman Islands', 'ky', '1345'], ['Central African Republic (République centrafricaine)', 'cf', '236'], ['Chad (Tchad)', 'td', '235'], ['Chile', 'cl', '56'], ['China (中国)', 'cn', '86'], ['Christmas Island', 'cx', '61', 2], ['Cocos (Keeling) Islands', 'cc', '61', 1], ['Colombia', 'co', '57'], ['Comoros (‫جزر القمر‬‎)', 'km', '269'], ['Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'cd', '243'], ['Congo (Republic) (Congo-Brazzaville)', 'cg', '242'], ['Cook Islands', 'ck', '682'], ['Costa Rica', 'cr', '506'], ['Côte d’Ivoire', 'ci', '225'], ['Croatia (Hrvatska)', 'hr', '385'], ['Cuba', 'cu', '53'], ['Curaçao', 'cw', '599', 0], ['Cyprus (Κύπρος)', 'cy', '357'], ['Czech Republic (Česká republika)', 'cz', '420'], ['Denmark (Danmark)', 'dk', '45'], ['Djibouti', 'dj', '253'], ['Dominica', 'dm', '1767'], ['Dominican Republic (República Dominicana)', 'do', '1', 2, ['809', '829', '849']], ['Ecuador', 'ec', '593'], ['Egypt (‫مصر‬‎)', 'eg', '20'], ['El Salvador', 'sv', '503'], ['Equatorial Guinea (Guinea Ecuatorial)', 'gq', '240'], ['Eritrea', 'er', '291'], ['Estonia (Eesti)', 'ee', '372'], ['Ethiopia', 'et', '251'], ['Falkland Islands (Islas Malvinas)', 'fk', '500'], ['Faroe Islands (Føroyar)', 'fo', '298'], ['Fiji', 'fj', '679'], ['Finland (Suomi)', 'fi', '358', 0], ['France', 'fr', '33'], ['French Guiana (Guyane française)', 'gf', '594'], ['French Polynesia (Polynésie française)', 'pf', '689'], ['Gabon', 'ga', '241'], ['Gambia', 'gm', '220'], ['Georgia (საქართველო)', 'ge', '995'], ['Germany (Deutschland)', 'de', '49'], ['Ghana (Gaana)', 'gh', '233'], ['Gibraltar', 'gi', '350'], ['Greece (Ελλάδα)', 'gr', '30'], ['Greenland (Kalaallit Nunaat)', 'gl', '299'], ['Grenada', 'gd', '1473'], ['Guadeloupe', 'gp', '590', 0], ['Guam', 'gu', '1671'], ['Guatemala', 'gt', '502'], ['Guernsey', 'gg', '44', 1], ['Guinea (Guinée)', 'gn', '224'], ['Guinea-Bissau (Guiné Bissau)', 'gw', '245'], ['Guyana', 'gy', '592'], ['Haiti', 'ht', '509'], ['Honduras', 'hn', '504'], ['Hong Kong (香港)', 'hk', '852'], ['Hungary (Magyarország)', 'hu', '36'], ['Iceland (Ísland)', 'is', '354'], ['India (भारत)', 'in', '91'], ['Indonesia', 'id', '62'], ['Iran (‫ایران‬‎)', 'ir', '98'], ['Iraq (‫العراق‬‎)', 'iq', '964'], ['Ireland', 'ie', '353'], ['Isle of Man', 'im', '44', 2], ['Israel (‫ישראל‬‎)', 'il', '972'], ['Italy (Italia)', 'it', '39', 0], ['Jamaica', 'jm', '1876'], ['Japan (日本)', 'jp', '81'], ['Jersey', 'je', '44', 3], ['Jordan (‫الأردن‬‎)', 'jo', '962'], ['Kazakhstan (Казахстан)', 'kz', '7', 1], ['Kenya', 'ke', '254'], ['Kiribati', 'ki', '686'], ['Kosovo', 'xk', '383'], ['Kuwait (‫الكويت‬‎)', 'kw', '965'], ['Kyrgyzstan (Кыргызстан)', 'kg', '996'], ['Laos (ລາວ)', 'la', '856'], ['Latvia (Latvija)', 'lv', '371'], ['Lebanon (‫لبنان‬‎)', 'lb', '961'], ['Lesotho', 'ls', '266'], ['Liberia', 'lr', '231'], ['Libya (‫ليبيا‬‎)', 'ly', '218'], ['Liechtenstein', 'li', '423'], ['Lithuania (Lietuva)', 'lt', '370'], ['Luxembourg', 'lu', '352'], ['Macau (澳門)', 'mo', '853'], ['Macedonia (FYROM) (Македонија)', 'mk', '389'], ['Madagascar (Madagasikara)', 'mg', '261'], ['Malawi', 'mw', '265'], ['Malaysia', 'my', '60'], ['Maldives', 'mv', '960'], ['Mali', 'ml', '223'], ['Malta', 'mt', '356'], ['Marshall Islands', 'mh', '692'], ['Martinique', 'mq', '596'], ['Mauritania (‫موريتانيا‬‎)', 'mr', '222'], ['Mauritius (Moris)', 'mu', '230'], ['Mayotte', 'yt', '262', 1], ['Mexico (México)', 'mx', '52'], ['Micronesia', 'fm', '691'], ['Moldova (Republica Moldova)', 'md', '373'], ['Monaco', 'mc', '377'], ['Mongolia (Монгол)', 'mn', '976'], ['Montenegro (Crna Gora)', 'me', '382'], ['Montserrat', 'ms', '1664'], ['Morocco (‫المغرب‬‎)', 'ma', '212', 0], ['Mozambique (Moçambique)', 'mz', '258'], ['Myanmar (Burma) (မြန်မာ)', 'mm', '95'], ['Namibia (Namibië)', 'na', '264'], ['Nauru', 'nr', '674'], ['Nepal (नेपाल)', 'np', '977'], ['Netherlands (Nederland)', 'nl', '31'], ['New Caledonia (Nouvelle-Calédonie)', 'nc', '687'], ['New Zealand', 'nz', '64'], ['Nicaragua', 'ni', '505'], ['Niger (Nijar)', 'ne', '227'], ['Nigeria', 'ng', '234'], ['Niue', 'nu', '683'], ['Norfolk Island', 'nf', '672'], ['North Korea (조선 민주주의 인민 공화국)', 'kp', '850'], ['Northern Mariana Islands', 'mp', '1670'], ['Norway (Norge)', 'no', '47', 0], ['Oman (‫عُمان‬‎)', 'om', '968'], ['Pakistan (‫پاکستان‬‎)', 'pk', '92'], ['Palau', 'pw', '680'], ['Palestine (‫فلسطين‬‎)', 'ps', '970'], ['Panama (Panamá)', 'pa', '507'], ['Papua New Guinea', 'pg', '675'], ['Paraguay', 'py', '595'], ['Peru (Perú)', 'pe', '51'], ['Philippines', 'ph', '63'], ['Poland (Polska)', 'pl', '48'], ['Portugal', 'pt', '351'], ['Puerto Rico', 'pr', '1', 3, ['787', '939']], ['Qatar (‫قطر‬‎)', 'qa', '974'], ['Réunion (La Réunion)', 're', '262', 0], ['Romania (România)', 'ro', '40'], ['Russia (Россия)', 'ru', '7', 0], ['Rwanda', 'rw', '250'], ['Saint Barthélemy', 'bl', '590', 1], ['Saint Helena', 'sh', '290'], ['Saint Kitts and Nevis', 'kn', '1869'], ['Saint Lucia', 'lc', '1758'], ['Saint Martin (Saint-Martin (partie française))', 'mf', '590', 2], ['Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', 'pm', '508'], ['Saint Vincent and the Grenadines', 'vc', '1784'], ['Samoa', 'ws', '685'], ['San Marino', 'sm', '378'], ['São Tomé and Príncipe (São Tomé e Príncipe)', 'st', '239'], ['Saudi Arabia (‫المملكة العربية السعودية‬‎)', 'sa', '966'], ['Senegal (Sénégal)', 'sn', '221'], ['Serbia (Србија)', 'rs', '381'], ['Seychelles', 'sc', '248'], ['Sierra Leone', 'sl', '232'], ['Singapore', 'sg', '65'], ['Sint Maarten', 'sx', '1721'], ['Slovakia (Slovensko)', 'sk', '421'], ['Slovenia (Slovenija)', 'si', '386'], ['Solomon Islands', 'sb', '677'], ['Somalia (Soomaaliya)', 'so', '252'], ['South Africa', 'za', '27'], ['South Korea (대한민국)', 'kr', '82'], ['South Sudan (‫جنوب السودان‬‎)', 'ss', '211'], ['Spain (España)', 'es', '34'], ['Sri Lanka (ශ්‍රී ලංකාව)', 'lk', '94'], ['Sudan (‫السودان‬‎)', 'sd', '249'], ['Suriname', 'sr', '597'], ['Svalbard and Jan Mayen', 'sj', '47', 1], ['Swaziland', 'sz', '268'], ['Sweden (Sverige)', 'se', '46'], ['Switzerland (Schweiz)', 'ch', '41'], ['Syria (‫سوريا‬‎)', 'sy', '963'], ['Taiwan (台灣)', 'tw', '886'], ['Tajikistan', 'tj', '992'], ['Tanzania', 'tz', '255'], ['Thailand (ไทย)', 'th', '66'], ['Timor-Leste', 'tl', '670'], ['Togo', 'tg', '228'], ['Tokelau', 'tk', '690'], ['Tonga', 'to', '676'], ['Trinidad and Tobago', 'tt', '1868'], ['Tunisia (‫تونس‬‎)', 'tn', '216'], ['Turkey (Türkiye)', 'tr', '90'], ['Turkmenistan', 'tm', '993'], ['Turks and Caicos Islands', 'tc', '1649'], ['Tuvalu', 'tv', '688'], ['U.S. Virgin Islands', 'vi', '1340'], ['Uganda', 'ug', '256'], ['Ukraine (Україна)', 'ua', '380'], ['United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', 'ae', '971'], ['United Kingdom', 'gb', '44', 0], ['United States', 'us', '1', 0], ['Uruguay', 'uy', '598'], ['Uzbekistan (Oʻzbekiston)', 'uz', '998'], ['Vanuatu', 'vu', '678'], ['Vatican City (Città del Vaticano)', 'va', '39', 1], ['Venezuela', 've', '58'], ['Vietnam (Việt Nam)', 'vn', '84'], ['Wallis and Futuna (Wallis-et-Futuna)', 'wf', '681'], ['Western Sahara (‫الصحراء الغربية‬‎)', 'eh', '212', 1], ['Yemen (‫اليمن‬‎)', 'ye', '967'], ['Zambia', 'zm', '260'], ['Zimbabwe', 'zw', '263'], ['Åland Islands', 'ax', '358', 1]];

for (var i = 0; i < allCountries.length; i++) {
  var c = allCountries[i];
  allCountries[i] = {
    name: c[0],
    icon: c[1],
    iso2: c[1].toUpperCase(),
    dialCode: c[2],
    priority: c[3] || 0,
    areaCodes: c[4] || null
  };
}

/* harmony default export */ __webpack_exports__["a"] = (allCountries);

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['input-tel', {'md-disabled': _vm.disabled}]},[_c('div',{staticClass:"input-tel-flag-list"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{class:"input-tel-flag",on:{"click":_vm.openSelect}},[_vm._v("\n      "+_vm._s(_vm.dialCode)+"\n    ")]),_vm._v(" "),_c('md-menu',{attrs:{"md-active":_vm.open},on:{"update:mdActive":function($event){_vm.open=$event},"update:md-active":function($event){_vm.open=$event}}},[_c('md-menu-content',_vm._l((_vm.allCountries),function(item){return _c('md-menu-item',{key:item['iso2'],on:{"click":function($event){return _vm.choose(item['iso2'])}}},[_c('span',{staticClass:"country-name"},[_vm._v(_vm._s(item.name))])])}),1)],1)],1),_vm._v(" "),_c('md-field',{staticClass:"input-tel-number"},[_c('md-input',{attrs:{"id":_vm.name,"name":_vm.name,"required":"","disabled":_vm.disabled},on:{"keypress":_vm.onlyNumber},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var disclaimersLabels = {
          'germany': 'Gesch\xE4ftsf\xFChrung: Matthias Schmidt-Pfitzner, Albert Neil Fins,  Sudeepto Mukherjee; Handelsregister: Amtsgericht M\xFCnchen; HRB 161057; Sitz der Gesellschaft: M\xFCnchen; USt.-IdNr. DE-210831918<br/>\n              Diese E-Mail enth\xE4lt vertrauliche und/oder rechtlich gesch\xFCtzte Informationen. Wenn Sie nicht der richtige Adressat sind oder diese E-Mail irrt\xFCmlich erhalten haben, informieren Sie bitte sofort die Sapient GmbH unter +49 89 552 987-0 und l\xF6schen Sie diese E-Mail. Das unerlaubte Kopieren sowie die unbefugte Weitergabe dieser E-Mail und der darin enthaltenen Informationen ist nicht gestattet. Vielen Dank.',

          'uk': 'Sapient Limited is a company registered in England and Wales with company number 3144067, Eden House, 8 Spital Square, London E1 6DU, webmaster@sapient.com. VAT Number 718603436\n          This e-mail may contain confidential and/or privileged information. If you are not the intended recipient (or have received this email in error) please immediately notify Sapient Limited on +44 207 786 4500 and delete this e-mail. Any unauthorized copying, disclosure or distribution of the material in this e-mail is strictly forbidden. Thank you for your cooperation.',

          'usa': 'The information transmitted is intended only for the person or entity to which it is addressed and may contain\n          confidential and/or privileged material. Any review, retransmission, dissemination or other use of, or taking of\n          any action in reliance upon, this information by persons or entities other than the intended recipient is prohibited.\n          If you received this in error, please contact the sender and delete the material from any computer.',

          'zurich': 'Gesch\xE4ftsf\xFChrung: Rolf Hartmann, Bruno Hunziker, Markus Ruhl\n            UID-Nummer: CHE-113.720.653, Sitz der Gesellschaft: Z\xFCrich\n            Mehrwertsteuer-Nummer: CHE-199.340.505 MWST<br/>\n            Diese E-Mail enth\xE4lt vertrauliche und/oder rechtlich gesch\xFCtzte Informationen. Wenn Sie nicht der richtige Adressat sind oder diese E-Mail irrt\xFCmlich erhalten haben, informieren Sie bitte sofort die Sapient Switzerland GmbH unter +41 58 206 0600 und l\xF6schen Sie diese E-Mail. Das unerlaubte Kopieren sowie die unbefugte Weitergabe dieser E-Mail und der darin enthaltenen Informationen ist nicht gestattet. Vielen Dank.\n            This e-mail may contain confidential and/or privileged information. If you are not the intended recipient (or have received this email in error) please immediately notify Sapient Switzerland GmbH on +41 58 206 0600 and delete this e-mail. Any unauthorized copying, disclosure or distribution of the material in this e-mail is strictly forbidden. Thank you for your cooperation.',

          'geneva': 'Gesch\xE4ftsf\xFChrung: Rolf Hartmann, Bruno Hunziker, Markus Ruhl\n            UID-Nummer: CHE-113.720.653, Sitz der Gesellschaft: Z\xFCrich\n            Mehrwertsteuer-Nummer: CHE-199.340.505 MWST<br/>\n            Diese E-Mail enth\xE4lt vertrauliche und/oder rechtlich gesch\xFCtzte Informationen. Wenn Sie nicht der richtige Adressat sind oder diese E-Mail irrt\xFCmlich erhalten haben, informieren Sie bitte sofort die Sapient Switzerland GmbH unter +41 58 206 0600 und l\xF6schen Sie diese E-Mail. Das unerlaubte Kopieren sowie die unbefugte Weitergabe dieser E-Mail und der darin enthaltenen Informationen ist nicht gestattet. Vielen Dank.<br/>\n            This e-mail may contain confidential and/or privileged information. If you are not the intended recipient (or have received this email in error) please immediately notify Sapient Switzerland GmbH on +41 58 206 0600 and delete this e-mail. Any unauthorized copying, disclosure or distribution of the material in this e-mail is strictly forbidden. Thank you for your cooperation.',

          'stockholm': 'Sapient Sweden AB Registration number (VAT): 556721-1965, Registered in: Stockholm<br/>\n                This e-mail may contain confidential and/or privileged information. If you are not the intended recipient (or have received this email in error) please immediately notify Sapient Sweden AB on +46 8 655 8550 and delete this e-mail. Any unauthorized copying, disclosure or distribution of the material in this e-mail is strictly forbidden. Thank you for your cooperation.'

};

/* harmony default export */ __webpack_exports__["a"] = (disclaimersLabels);

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('form',{staticClass:"md-layout",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.validateForm.apply(null, arguments)}}},[_c('div',{staticClass:"form-material md-layout md-gutter"},[_c('div',{staticClass:"form-material-left md-layout-item"},[_c('md-field',{class:_vm.getValidationClass('name')},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('form.name')))]),_vm._v(" "),_c('md-input',{attrs:{"name":"name","tabindex":"1","required":""},on:{"input":function($event){return _vm.sendData('name')}},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),(!_vm.$v.form.name.required)?_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(_vm.$t('form.name_required')))]):_vm._e()],1),_vm._v(" "),_c('md-field',{class:_vm.getValidationClass('job')},[_c('label',{attrs:{"for":"job"}},[_vm._v(_vm._s(_vm.$t('form.job')))]),_vm._v(" "),_c('md-input',{attrs:{"name":"job","tabindex":"3","required":""},on:{"input":function($event){return _vm.sendData('job')}},model:{value:(_vm.form.job),callback:function ($$v) {_vm.$set(_vm.form, "job", $$v)},expression:"form.job"}}),_vm._v(" "),(!_vm.$v.form.job.required)?_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(_vm.$t('form.job_required')))]):_vm._e()],1),_vm._v(" "),_c('md-field',[_c('label',{attrs:{"for":"pslogo"}},[_vm._v(_vm._s(_vm.$t('form.pslogo')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"pslogo","id":"pslogo","tabindex":"5"},on:{"md-selected":this.sendPSLogo},model:{value:(_vm.pslogo),callback:function ($$v) {_vm.pslogo=$$v},expression:"pslogo"}},_vm._l((_vm.pslogos),function(item,key){return _c('md-option',{key:key,attrs:{"value":key}},[_vm._v(_vm._s(_vm.$t(("form.pslogoList." + key)))+"\n            ")])}),1)],1),_vm._v(" "),_c('md-field',{staticClass:"accolades-list"},[_c('label',{attrs:{"for":"accolades"}},[_vm._v(_vm._s(_vm.$t('form.accolades')))]),_vm._v(" "),_c('md-select',{attrs:{"disabled":!_vm.office,"name":"accolades","id":"accolades","multiple":"","md-dense":"","tabindex":"7"},on:{"md-selected":this.sendAccolade},model:{value:(_vm.accolade),callback:function ($$v) {_vm.accolade=$$v},expression:"accolade"}},_vm._l((_vm.officeAccolades),function(item,key){return _c('md-option',{key:key,attrs:{"disabled":_vm.accolade.length >= 3 && _vm.accolade.indexOf(key) < 0,"value":key}},[_vm._v("\n              "+_vm._s(_vm.$t(("form.accoladesList." + key)))+"\n            ")])}),1)],1),_vm._v(" "),_c('tel-input',{attrs:{"label":_vm.$t('form.mobile'),"disabled":!_vm.office,"name":"mobile","tabindex":"0","default-iso":_vm.officeIsoCode,"default-value":_vm.mobile},on:{"update:phone":function($event){return _vm.phoneUpdated('mobile', 'formattedMobile', $event)}}}),_vm._v(" "),_c('div',{staticClass:"form-space"})],1),_vm._v(" "),_c('div',{staticClass:"form-material-right md-layout-item"},[_c('md-field',{class:_vm.getValidationClass('lastname')},[_c('label',{attrs:{"for":"lastname"}},[_vm._v(_vm._s(_vm.$t('form.lastname')))]),_vm._v(" "),_c('md-input',{attrs:{"name":"lastname","tabindex":"2","required":""},on:{"input":function($event){return _vm.sendData('lastname')}},model:{value:(_vm.form.lastname),callback:function ($$v) {_vm.$set(_vm.form, "lastname", $$v)},expression:"form.lastname"}}),_vm._v(" "),(!_vm.$v.form.lastname.required)?_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(_vm.$t('form.lastname_required')))]):_vm._e()],1),_vm._v(" "),_c('md-autocomplete',{attrs:{"name":"pronouns","md-options":_vm.$t('form.pronounsList'),"tabindex":"4"},on:{"input":function($event){return _vm.sendData('pronouns')}},model:{value:(_vm.form.pronouns),callback:function ($$v) {_vm.$set(_vm.form, "pronouns", $$v)},expression:"form.pronouns"}},[_c('ESPopin',{attrs:{"show-dialog":true,"title":_vm.$t('form.pronounsPopin.title'),"text":_vm.$t('form.pronounsPopin.text')}}),_vm._v(" "),_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('form.pronouns'))+"\n            ")])],1),_vm._v(" "),_c('md-field',{class:['office-list', _vm.getValidationClass('office')]},[_c('label',{attrs:{"for":"office"}},[_vm._v(_vm._s(_vm.$t('form.office')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"office","id":"office","tabindex":"6","required":""},on:{"md-selected":this.sendOffice},model:{value:(_vm.office),callback:function ($$v) {_vm.office=$$v},expression:"office"}},_vm._l((_vm.offices),function(item,key){return _c('md-option',{key:key,attrs:{"value":key}},[_vm._v("\n              "+_vm._s(item.location)+"\n            ")])}),1),_vm._v(" "),(!_vm.$v.office.required)?_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(_vm.$t('form.office_required')))]):_vm._e()],1),_vm._v(" "),_c('tel-input',{attrs:{"label":_vm.$t('form.phone'),"disabled":!_vm.office,"name":"phone","default-iso":_vm.officeIsoCode,"default-value":_vm.phone},on:{"update:phone":function($event){return _vm.phoneUpdated('phone', 'formattedPhone', $event)}}}),_vm._v(" "),_c('div',{staticClass:"form-space"})],1)]),_vm._v(" "),_c('div',{staticClass:"mentions md-layout-item md-size-100"},[_vm._v(_vm._s(_vm.$t('form.mentions')))])]),_vm._v(" "),_c('button',{staticClass:"buttonSign",attrs:{"type":"button"},on:{"click":_vm.integrate}},[_c('div',{staticClass:"front"},[_vm._v(_vm._s(_vm.$t("buttonIntegrate")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAvatar_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17805849_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAvatar_vue__ = __webpack_require__(541);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAvatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17805849_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAvatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColorRing_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_324fbb8f_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColorRing_vue__ = __webpack_require__(540);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColorRing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_324fbb8f_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColorRing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color--ring"},_vm._l((_vm.list),function(item){return _c('div',{key:item,class:['color--ring-item', {active: _vm.current === item}, !/^#/.test(item) ? 'no-border' : ''],style:([/^#/.test(item) ? {borderColor: item} : '']),on:{"click":function($event){return _vm.clickColor(item)}}},[(/^#/.test(item))?_c('span',{staticClass:"color--ring-check",style:({backgroundColor: item})}):_c('span',{staticClass:"color--ring-rainbow"},[_vm._m(0,true)])])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"color--ring-rainbow-inner"},[_c('span',{staticClass:"color--ring-rainbow-check"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"panels__side panels__side--left"},[_c('div',{staticClass:"panels__side panels__side--inner panels__side--form"},[_c('div',{staticClass:"form form--avatar"},[_c('div',{staticClass:"form-material md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item"},[_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPreview),expression:"!showPreview"}],staticClass:"h4"},[_vm._v(_vm._s(_vm.$t('avatar.photo.title')))]),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPreview),expression:"showPreview"}],staticClass:"h4"},[_vm._v(_vm._s(_vm.$t('avatar.photo.titleUploaded')))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"form--avatar__upload"},[_c('div',{staticClass:"select-text"},[_vm._v(_vm._s(_vm.$t('avatar.photo.select')))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t('avatar.photo.recommend')))]),_vm._v(" "),_c('ul',{staticClass:"recommendation-list"},[_c('li',[_vm._v("\n                    "+_vm._s(_vm.$t('avatar.photo.size'))+"\n                  ")]),_vm._v(" "),_c('li',[_vm._v("\n                    "+_vm._s(_vm.$t('avatar.photo.adjust'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form--avatar__upload-container"},[_c('div',{class:'form--avatar__upload-input ' + [(!/^#/.test(_vm.color) && _vm.showPreview)? _vm.color : '']},[_c('div',{on:{"click":_vm.triggerInputFile}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPreview),expression:"!showPreview"}],staticClass:"form--avatar__upload-input-label"},[_vm._v(_vm._s(_vm.$t('avatar.photo.upload')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPreview),expression:"!showPreview"}],staticClass:"form--avatar__upload-input-plus"},[_vm._v("+")])]),_vm._v(" "),_c('input',{ref:"file",attrs:{"type":"file","id":"file","accept":".jpg,.jpeg,.png,.gif,.bmp"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPreview),expression:"showPreview"},{name:"dragged",rawName:"v-dragged",value:(_vm.onDragged),expression:"onDragged"}],staticClass:"form--avatar__upload-img",style:({left: _vm.dragLeft, top: _vm.dragTop})},[_c('img',{style:({transform: ("scale(" + _vm.scalePreview + ")")}),attrs:{"src":_vm.imagePreview}})])]),_vm._v(" "),(/^#/.test(_vm.color))?_c('div',{staticClass:"form--avatar__upload-border",style:({borderColor: (_vm.showPreview) ? _vm.color : 'transparent'})}):(!/^#/.test(_vm.color))?_c('div',{class:[(!/^#/.test(_vm.color) && _vm.showPreview)? 'form--avatar__upload-border-rainbow' : '']}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPreview),expression:"showPreview"}],staticClass:"form--avatar__upload-update",on:{"click":_vm.triggerInputFile}},[_c('span',{staticClass:"button"},[_vm._v(_vm._s(_vm.$t('avatar.photo.change')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPreview),expression:"showPreview"}],staticClass:"range-container"},[_c('div',{staticClass:"range-container__control range-container__control--minus",on:{"click":function($event){return _vm.clickRange(- _vm.sliderStep)}}},[_vm._v("\n                  -\n                  "),_c('span',{staticClass:"range-container__control__info"},[_vm._v(_vm._s(_vm.$t('avatar.photo.zoomOut')))])]),_vm._v(" "),_c('range-slider',{staticClass:"slider",attrs:{"min":_vm.sliderMin,"max":_vm.sliderMax,"step":_vm.sliderStep},on:{"change":_vm.changeSliderEnd},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}}),_vm._v(" "),_c('div',{staticClass:"range-container__control range-container__control",on:{"click":function($event){return _vm.clickRange(_vm.sliderStep)}}},[_vm._v("\n                  +\n                  "),_c('span',{staticClass:"range-container__control__info"},[_vm._v(_vm._s(_vm.$t('avatar.photo.zoomIn')))])])],1),_vm._v(" "),_c('div',{staticClass:"color--ring-container"},[_c('h4',{staticClass:"h4"},[_vm._v(_vm._s(_vm.$t('avatar.color.title')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('avatar.color.select')))]),_vm._v(" "),_c('ColorRing',{attrs:{"list":['#fe414e', '#b4b4b4', '#000', 'rainbow']},on:{"change":_vm.clickColor}})],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"panels__side panels__side--inner panels__side--form"},[_c('div',{staticClass:"form form--avatar"},[_c('div',{staticClass:"form-material md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item"},[_c('h4',{staticClass:"h4"},[_vm._v(_vm._s(_vm.$t('avatar.review.title')))]),_vm._v(" "),_c('canvas',{ref:"canvas",attrs:{"height":"400","width":"400"}}),_vm._v(" "),_c('div',{staticClass:"instructions"},[_c('div',{staticClass:"instructions-tabs"},[_c('md-tabs',{staticClass:"md-transparent",on:{"md-changed":_vm.clickTab}},[_c('md-tab',{attrs:{"id":"instruction-tab-0","md-label":_vm.$t('avatar.instructions.title_vox')}}),_vm._v(" "),_c('md-tab',{attrs:{"id":"instruction-tab-1","md-label":_vm.$t('avatar.instructions.title_outlook_mac')}}),_vm._v(" "),_c('md-tab',{attrs:{"id":"instruction-tab-2","md-label":_vm.$t('avatar.instructions.title_outlook_windows')}}),_vm._v(" "),_c('md-tab',{attrs:{"id":"instruction-tab-3","md-label":_vm.$t('avatar.instructions.title_outlook_webmail')}}),_vm._v(" "),_c('md-tab',{attrs:{"id":"instruction-tab-4","md-label":_vm.$t('avatar.instructions.title_linkedin')}})],1),_vm._v(" "),_c('div',{staticClass:"md-content md-tabs-content md-theme-default"},[_c('div',{staticClass:"md-tabs-container"},[_c('div',{staticClass:"md-tab md-tab-margin",style:({marginLeft: _vm.tabsSlide + '%' })},[_c('div',{staticClass:"instructions-tabs__item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('avatar.instructions.vox'))}})]),_vm._v(" "),_c('a',{staticClass:"button",class:{ inactive: !_vm.download },attrs:{"href":_vm.download,"download":"avatar_vox"}},[_vm._v(_vm._s(_vm.$t('avatar.review.download')))])]),_vm._v(" "),_c('div',{staticClass:"md-tab"},[_c('div',{staticClass:"instructions-tabs__item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('avatar.instructions.outlook_mac'))}})]),_vm._v(" "),_c('a',{staticClass:"button",class:{ inactive: !_vm.downloadBg },attrs:{"href":_vm.downloadBg,"download":"avatar_outlook_mac"}},[_vm._v(_vm._s(_vm.$t('avatar.review.download')))])]),_vm._v(" "),_c('div',{staticClass:"md-tab"},[_c('div',{staticClass:"instructions-tabs__item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('avatar.instructions.outlook_windows'))}})]),_vm._v(" "),_c('a',{staticClass:"button",class:{ inactive: !_vm.downloadBg },attrs:{"href":_vm.downloadBg,"download":"avatar_outlook_windows"}},[_vm._v(_vm._s(_vm.$t('avatar.review.download')))])]),_vm._v(" "),_c('div',{staticClass:"md-tab"},[_c('div',{staticClass:"instructions-tabs__item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('avatar.instructions.outlook_webmail'))}})]),_vm._v(" "),_c('a',{staticClass:"button",class:{ inactive: !_vm.downloadBg },attrs:{"href":_vm.downloadBg,"download":"avatar_outlook_webmail"}},[_vm._v(_vm._s(_vm.$t('avatar.review.download')))])]),_vm._v(" "),_c('div',{staticClass:"md-tab"},[_c('div',{staticClass:"instructions-tabs__item"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('avatar.instructions.linkedin'))}})]),_vm._v(" "),_c('a',{staticClass:"button",class:{ inactive: !_vm.downloadBigStroke },attrs:{"href":_vm.downloadBigStroke,"download":"avatar_linkedin"}},[_vm._v(_vm._s(_vm.$t('avatar.review.download')))])])])])],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Outlook_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a20bcba_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Outlook_vue__ = __webpack_require__(543);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Outlook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a20bcba_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Outlook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outlook"},[_c('div',{staticClass:"window"},[_c('div',{staticClass:"window-title"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"window-object"},[_vm._v(_vm._s(_vm.$t("mail.title")))])]),_vm._v(" "),(false)?_c('div',{staticClass:"window-toolbar"},[_c('img',{attrs:{"src":"static/svg/delete.svg","width":"30"}}),_vm._v(" "),_c('div',{staticClass:"window-toolbar-separator"}),_vm._v(" "),_c('img',{attrs:{"src":"static/svg/reply.svg","width":"30"}}),_vm._v(" "),_c('img',{attrs:{"src":"static/svg/reply-all.svg","width":"30"}}),_vm._v(" "),_c('img',{attrs:{"src":"static/svg/forward.svg","width":"30"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"window-body"},[_c('div',{staticClass:"window-header"},[_vm._m(1),_vm._v(" "),_c('div',[_c('span',{staticClass:"window-header_object"},[_vm._v(_vm._s(_vm.$t("mail.object")))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"window-header_dest"},[_vm._v(_vm._s(_vm.$t("mail.to"))),_c('span',{staticClass:"window-header_pastille"}),_vm._v(_vm._s(_vm.$t("mail.recipient")))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"window-preview"},[_vm._v(_vm._s(_vm.typing))]),_vm._v(" "),_c('div',{staticClass:"outlook-signature",attrs:{"id":"outlook-signature"}},[_c('table',{staticStyle:{"background":"#ffffff"},attrs:{"width":"350","cellspacing":"0","cellpadding":"0","border":"0","bgcolor":"#ffffff"}},[_c('tr',[_c('td',{staticStyle:{"vertical-align":"top","text-align":"left","color":"#231f20","font-size":"13px","font-family":"arial, helvetica"}},[_c('span',{staticStyle:{"color":"#231f20","font-size":"13px","font-family":"arial, helvetica"}},[_vm._v(_vm._s(_vm.name)+" "+_vm._s(_vm.lastname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#666666","font-size":"13px","font-family":"arial, helvetica"}},[_vm._v(_vm._s(_vm.job))]),_vm._v(" "),(_vm.pronouns)?_c('span',{staticStyle:{"color":"#666666","font-size":"13px","font-family":"arial, helvetica"}},[_c('br'),_vm._v(_vm._s(_vm.$t('mail.pronouns'))+": "+_vm._s(_vm.pronouns))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"title":"PublicisSapient","target":"_blank","href":_vm.redirect_url}},[_c('img',{staticStyle:{"padding-bottom":"0","display":"inline !important","vertical-align":"bottom","border":"0","outline":"none","text-decoration":"none","-ms-interpolation-mode":"bicubic"},attrs:{"width":_vm.pslogos[_vm.pslogo].width,"height":_vm.pslogos[_vm.pslogo].height,"align":"center","title":"PublicisSapient","alt":"PublicisSapient","src":_vm.pslogos[_vm.pslogo].url}})]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.office)?_c('span',{staticStyle:{"color":"#666666","font-size":"13px","font-family":"arial, helvetica","text-decoration":"none"},domProps:{"innerHTML":_vm._s(_vm.offices[_vm.office].address)}}):_vm._e(),_vm._v(" "),(_vm.mobile || _vm.phone)?_c('br'):_vm._e(),_vm._v(" "),(_vm.mobile || _vm.phone)?_c('br'):_vm._e(),_vm._v(" "),(_vm.phone)?_c('span',{staticStyle:{"color":"#666666","text-decoration":"none"}},[_vm._v("T   "+_vm._s(_vm.formattedPhone)),(_vm.mobile)?_c('br'):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.mobile)?_c('span',{staticStyle:{"color":"#666666","text-decoration":"none"}},[_vm._v("M  "+_vm._s(_vm.formattedMobile))]):_vm._e()])])]),_vm._v(" "),(_vm.accolade.length)?_c('br'):_vm._e(),_vm._v(" "),_vm._l((_vm.accolade),function(acc){return _c('span',{key:acc},[(_vm.accolades[acc] && _vm.accolades[acc].url)?_c('span',[(!_vm.accolades[acc].href)?_c('strong',{attrs:{"width":_vm.accolades[acc].width}},[(!_vm.accolades[acc].href)?_c('img',{staticStyle:{"padding-bottom":"0","display":"inline !important","vertical-align":"bottom","border":"0","outline":"none","text-decoration":"none","-ms-interpolation-mode":"bicubic"},attrs:{"width":_vm.accolades[acc].width,"height":_vm.accolades[acc].height,"align":"center","alt":"","src":_vm.accolades[acc].url}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.accolades[acc].href)?_c('a',{attrs:{"href":_vm.accolades[acc].href,"target":"_blank"}},[_c('img',{staticStyle:{"padding-bottom":"0","display":"inline !important","vertical-align":"bottom","border":"0","outline":"none","text-decoration":"none","-ms-interpolation-mode":"bicubic"},attrs:{"width":_vm.accolades[acc].width,"height":_vm.accolades[acc].height,"align":"center","alt":"","src":_vm.accolades[acc].url}})]):_vm._e(),_vm._v("     \n          ")]):_vm._e()])}),_vm._v(" "),(_vm.accolade.length)?_c('br'):_vm._e(),_vm._v(" "),(_vm.donate)?_c('br'):_vm._e(),_vm._v(" "),(_vm.donate)?_c('br'):_vm._e(),_vm._v(" "),(_vm.donate)?_c('table',{staticClass:"donate",staticStyle:{"width":"100%","color":"#666666","font-size":"13px","font-family":"arial, helvetica"},attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tr',[_vm._m(2),_vm._v(" "),_c('td',{staticClass:"donate-object",staticStyle:{"padding-left":"8px","color":"rgb(102, 102, 102)","font-size":"10px","font-family":"arial, helvetica","line-height":"14px"},domProps:{"innerHTML":_vm._s(_vm.$t('mail.donate_ukraine'))}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.office && _vm.offices[_vm.office].disclaimer)?_c('span',{staticStyle:{"padding-top":"10px","color":"#666666","text-decoration":"none","font-size":"9px","font-family":"arial, helvetica"},domProps:{"innerHTML":_vm._s(_vm.offices[_vm.office].disclaimer)}}):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"ga_generate"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"window-buttons"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"window-header_avatar"},[_c('img',{attrs:{"src":"static/svg/avatar.svg","width":"46"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"donate-flag",attrs:{"width":"24"}},[_c('a',{attrs:{"href":"https://helping-our-ukraine-team-as-one.iraiser.eu/b/my-donation?cid=1&_cv=1"}},[_c('img',{attrs:{"src":"https://ps-email-signature-generator.s3.amazonaws.com/Aperture_Ukraine.png","width":"24","height":"24"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Title_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631eaecc_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Title_vue__ = __webpack_require__(545);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631eaecc_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.headerGet)?_c('div',{staticClass:"title animated fadeIn",class:{ headerNoAvatarYes: !_vm.headerGet && _vm.avatarGet }},[_c('div',{staticClass:"title--inner"},[(!_vm.logoGet && !_vm.headerGet)?_c('span',{staticClass:"title-sapient animated fadeIn"},[_c('img',{attrs:{"src":"static/svg/logo-sapient.svg","alt":"Publicis Sapient","width":"65"}})]):_vm._e(),_vm._v(" "),(!_vm.titleGet && !_vm.headerGet)?_c('h1',{staticClass:"animated fadeIn h1",domProps:{"innerHTML":_vm._s(_vm.$t(("title_" + _vm.currentTab)))}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title--slot"},[_vm._t("default")],2)])]):_vm._e(),_vm._v(" "),(_vm.headerGet && _vm.avatarGet)?_c('div',{staticClass:"title animated fadeIn noHeader"},[_c('div',{staticClass:"title--slot"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instructions_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b60e8a_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instructions_vue__ = __webpack_require__(547);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instructions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b60e8a_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instructions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instructions"},[_c('h3',[_vm._v(_vm._s(_vm.$t("installation")))]),_vm._v(" "),_c('span',{staticClass:"instructions-title"},[_vm._v(_vm._s(_vm.$t("titleFollowInstructions")))]),_vm._v(" "),_c('div',{staticClass:"instructions-tabs"},[_c('md-tabs',{staticClass:"md-transparent"},[_c('md-tab',{attrs:{"md-label":_vm.$t('instructions.title_outlook_windows')},on:{"click":function($event){return _vm.clickTabs('pc')}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('instructions.outlook_windows'))}})]),_vm._v(" "),_c('md-tab',{attrs:{"md-label":_vm.$t('instructions.title_outlook_mac')},on:{"click":function($event){return _vm.clickTabs('mac')}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('instructions.outlook_mac'))}})]),_vm._v(" "),_c('md-tab',{attrs:{"md-label":_vm.$t('instructions.title_webmail')},on:{"click":function($event){return _vm.clickTabs('webmail')}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('instructions.webmail'))}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"instructions-btns"},[_c('button',{staticClass:"buttonSign buttonIntegrate",attrs:{"type":"button"},on:{"click":_vm.integrate}},[_c('div',{staticClass:"front"},[_vm._v(_vm._s(_vm.$t("buttonIntegrate"))+" ›")]),_vm._v(" "),_c('div',{staticClass:"back"},[_vm._v(_vm._s(_vm.$t("buttonBack")))])]),_vm._v(" "),_c('button',{directives:[{name:"tippy",rawName:"v-tippy",value:({ interactive : false, trigger: 'click' }),expression:"{ interactive : false, trigger: 'click' }"}],ref:"buttonTooltip",staticClass:"buttonSign buttonCopyCode",class:['buttonSign', 'buttonCopyCode', { disabled: _vm.disabled }],attrs:{"title":_vm.$t('copiedClipboard')},on:{"click":function($event){return _vm.copyCode()}}},[_vm._v(_vm._s(_vm.$t("buttonCopySignature")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f26fc4c2_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__(549);
var normalizeComponent = __webpack_require__(33)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f26fc4c2_hasScoped_false_transformToRequire_audio_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{attrs:{"md-active":_vm.showDialog,"md-backdrop":false},on:{"update:mdActive":function($event){_vm.showDialog=$event},"update:md-active":function($event){_vm.showDialog=$event}}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$t('errorTitle')))]),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])])]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.showDialog = false}}},[_vm._v(_vm._s(_vm.$t('popinClose')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ESTitle',{attrs:{"currentTab":_vm.active}},[(_vm.avatarGet)?_c('div',{staticClass:"tabs-page"},[_c('button',{class:{active: _vm.active === 'email'},attrs:{"type":"button"},on:{"click":function($event){_vm.active = 'email'}}},[_vm._v(_vm._s(_vm.$t('tabs.email')))]),_vm._v(" "),_c('button',{class:{active: _vm.active === 'avatar'},attrs:{"type":"button"},on:{"click":function($event){_vm.active = 'avatar'}}},[_vm._v(_vm._s(_vm.$t('tabs.avatar')))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"main-app overflow animated slideInUp"},[_c('transition',{attrs:{"name":"panels"}},[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.active === 'email'),expression:"active === 'email'"}],staticClass:"panels"},[_c('div',{staticClass:"md-layout top-mentions"},[(!_vm.avatarGet)?_c('h1',{staticClass:"h1"},[_vm._v(_vm._s(_vm.$t('tabs.email')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"md-layout-item md-size-100"},[_vm._v(_vm._s(_vm.$t('topMentions')))])]),_vm._v(" "),_c('article',{staticClass:"panels__side panels__side--left"},[_c('div',{staticClass:"panels__side panels__side--inner panels__side--form"},[_c('ESForm')],1),_vm._v(" "),_c('div',{staticClass:"panels__side panels__side--inner panels__side--instruction"},[_c('ESInstructions')],1)]),_vm._v(" "),_c('article',{staticClass:"panels__side panels__side--right panels__side--outlook"},[_c('div',{staticClass:"panels__side panels__side--inner"},[_c('ESOutlook')],1)])])]),_vm._v(" "),_c('transition',{attrs:{"name":"panels"}},[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.active === 'avatar'),expression:"active === 'avatar'"}],staticClass:"panels"},[_c('div',{staticClass:"md-layout top-mentions"},[(!_vm.avatarGet)?_c('h1',{staticClass:"h1"},[_vm._v(_vm._s(_vm.$t('tabs.avatar')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"md-layout-item md-size-100"},[_vm._v(_vm._s(_vm.$t('avatar.topMentions')))])]),_vm._v(" "),_c('FormAvatar')],1)])],1),_vm._v(" "),_c('div',{staticClass:"lang lang--fr",on:{"click":function($event){return _vm.changeLang()}}},[_c('span',[_vm._v("FR")]),_vm._v(" "),_c('span',[_vm._v("EN")])]),_vm._v(" "),_c('ESError')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var labels = {
  en: {
    title_email: 'Customize your email signature!',
    title_avatar: 'Get your customized avatar!',
    topMentions: 'Get your own Publicis Sapient email signature in less than 1 minute.',
    buttonIntegrate: 'Integrate your signature',
    copiedClipboard: 'Copied in clipboard!',
    installation: 'Email signature integration',
    buttonCopySignature: 'Copy the signature',
    buttonBack: 'Back',
    titleFollowInstructions: 'Follow the steps',
    errorTitle: 'Oups',
    popinClose: 'Close',
    mail: {
      title: 'Customize your email signature!',
      object: 'My email signature',
      to: 'To:',
      recipient: 'ALL@publicissapient.com',
      courtesy: 'Hi everyone! Just a quick email to show you your brand new Publicis Sapient signature! Not bad huh? Try for yourself ;)',
      mobileLetter: 'M',
      phoneLetter: 'P',
      pronouns: 'Pronouns',
      donate_ukraine: '<a href="https://helping-our-ukraine-team-as-one.iraiser.eu/b/my-donation?cid=1&_cv=1" style="padding-top: 10px; color: #666666; text-decoration: none;font-size: 10px; font-family: arial, helvetica; text-decoration: underline; line-height: 14px;" target="_blank"\n      aria-description="Donate Now to Publicis Groupe Fundraiser for Our Team in Ukraine.">\n        Donate Now to Publicis Groupe Fundraiser <br />for Our Team in Ukraine.</a>'
    },
    tabs: {
      email: 'Create your signature',
      avatar: 'Create your avatar'
    },
    form: {
      name: 'First Name',
      name_required: 'The name is required',
      lastname: 'Last Name',
      lastname_required: 'The last name is required',
      job: 'Title',
      job_required: 'The job title is required',
      pronouns: 'Pronouns (optional)',
      pronounsList: ['she/they', 'he/they', 'she/her/hers', 'he/him/his', 'they/them/theirs'],
      pronounsPopin: {
        title: 'Include your pronouns:',
        text: 'Publicis Sapient represents a diverse set of gender identities and expressions. If you’d like to ensure you’re addressed by the correct pronouns, or demonstrate your support for gender inclusivity, add yours here. <br/><a target="_blank" href="https://marcel.ai/app/article/8f06fac0-3ff7-5304-ab0e-2e349e139ed3">Read why pronouns matter</a>'
      },
      pslogo: 'Logo',
      pslogoList: {
        PS_Brand: 'PS Brand',
        PS_Pride: 'PS Pride'
      },
      office: 'Office',
      office_required: 'The office is required',
      mobile: 'Mobile',
      phone: 'Phone',

      accolades: 'Select your Accolades (optional)',
      accoladesList: {
        consulting_reports_top_50_consulting_firms: '2024 Consulting Report\'s Top 50 Consulting Firms',
        forbes_worlds_best_management_consulting_firms: '2024 Forbes World\'s Best Management Consulting Firms',
        HFS_generative_enterprise_services_market_leader_2023: 'HFS Generative Enterprise Services Market Leader, 2023',
        idc_marketScape_for_worldwide_experience_design_2023_24: 'IDC MarketScape for Worldwide Experience Design, 2023-24',
        e_footprint: 'e-footprint',
        google_cloud_partner_of_the_year_2024: 'Google Cloud Partner of the Year 2024',
        VivaTech_2024: 'VivaTech 2024',
        disability_confident_employer: 'Disability Confident Employer',
        guide_to_next: 'Guide to Next',
        consulting_magazine_best_firms_to_work_for_2023: ' Consulting Magazine Best Firms to Work For 2023',
        Consultancy_uk_Top_Consulting_Firms_in_UK_2023: 'Consultancy.uk - Top Consulting Firms in UK 2023',
        consulting_report_top_consulting_firm_2023: 'Consulting Report – Top Consulting Firm 2023',
        carbon_markets: 'Carbon Markets',
        get_ahead_cp: 'Get Ahead - CP',
        seize_the_space_t_h: 'Seize the Space - T&H',
        vault_emea: 'Vault Best Consulting Firms – EMEA',
        vault_north_america: 'Vault Best Consulting Firms – North America',
        vault_apac: 'Vault Best Consulting Firms – APAC',
        workingwithcancer: '#workingwithcancer',
        great_place_to_work_germany: 'Great Place to Work - Germany',
        great_place_to_work_us: 'Great Place to Work - US',
        iDBT: 'iDBT',
        consulting_magazine_best_firms: 'Consulting Magazine Best Firms',
        school_of_next: 'School of Next',
        forbes_best_consulting_firms: 'Forbes Best Consulting Firms',
        egalite: 'ÉGALITÉ',
        shopper_first_retail: 'Shopper First Retail',
        uk_financial_times: 'UK Financial Times',
        human_rights_campaign: 'Human Rights Campaign',
        energy_tech_awards: 'EnergyTech Awards',
        tech_women: 'We Are Tech Women',
        gptw_germany: 'Great Place to Work (Germany), 2019-20',
        certified_great_place: 'Great Place to Work (India), 2019-20',
        the_how_channel: 'The HOW Channel',
        enable: 'enABLE',
        gartner_peer_insights: 'Gartner Peer Insights',
        idc_marketscape_2: 'IDC MarketScape',
        gartner_topscorercx: 'Gartner Top Scorer',
        gartner_magic_quadrant: 'Gartner Magic Quadrant',
        vault_top_ranked_internship_program_2025: 'Vault Top Ranked Internship Program, 2025',
        vault_top_ranked_internship_program_lgbtq_2025: 'Vault Top Ranked Internship Program for LGBTQ+ Individuals, 2025',
        VivaTech_2025: 'VivaTech 2025',
        none: 'None'
      },
      mentions: 'Don’t worry, your personal data won’t be registered.',
      donate: 'To support our colleagues in Ukraine add this message.'
    },
    instructions: {
      title_outlook_mac: 'Outlook Mac',
      title_outlook_windows: 'Outlook Windows',
      title_webmail: 'Webmail',
      outlook_mac: '\n      <p>1. Click on the <span>Copy the signature</span> button below</p>\n      <p>2. In the menu bar, select <span>Outlook \u203A Preferences</span> and then click on <span>Signatures</span></p>\n      <p>3. Click on <span>[+]</span> and enter a name for your new signature</p>\n      <p>4. Paste your signature (Cmd + V)<br>\n      In Outlook 2016, make sure you select the <span>keep source formatting option</span> in the Paste Options menu</p>\n      <p>5. Save then select your new signature in the <span>New messages</span> and <span>Replies/ forwards</span> dropdown menus</p>\n      <img src="static/img/options-collage-en.jpg" alt="">\n      ',
      outlook_windows: '\n      <p>1. Click on the <span>Copy the signature</span> button below</p>\n      <p>2a. For older outlook version: <span>Go to File \u203A Options \u203A Mail</span>. In the <span>Compose messages</span> section, click on <span>Signatures</span></p>\n      <p>2b. For newer outlook version: <span>Go to File \u203A Settings \u203A Accounts > Signatures</span></p>\n      <p>3. Click on <span>New</span> and enter a name for your new signature</p>\n      <p>4. Paste your signature (Ctrl + V) in the <span>Edit signature field</span></p>\n      <p>5. On right hand side, under <span>Choose default signature</span>, select your email account</p>\n      <p>6. Select your new signature in the <span>New messages</span> and <span>Replies/forwards</span> dropdown menus</p>\n      ',
      webmail: '\n      <p>1. Click on the <span>Copy the signature</span> button below</p>\n      <p>2. Click on the <span>Settings</span> icon on the top right hand corner to open the <span>Parameters</span> menu and type <span>"Email Signature"</span> in the search bar</p>\n      <p>3. Paste your signature (Ctrl + V) in the <span>email signature field</span></p>\n      <p>4. Check the <span>Automatically include my signature on messages I send</span> box</p>\n      '
    },
    avatar: {
      topMentions: 'Get your branded Publicis Sapient profile picture in a few clicks.',
      photo: {
        title: 'Step 1. Upload your profile picture',
        titleUploaded: 'Step 1. Avatar Review',
        upload: 'Upload a photo',
        select: 'Select a photo from your computer (accepted formats: JPG, PNG, GIF, Bitmap).',
        recommend: 'The recommended dimensions for your avatar image:',
        size: 'Minimum size of 200 pixels by 200 pixels.',
        adjust: 'You will be able to edit to adjust the image by enlarging or reducing the size.',
        change: 'Change Photo',
        zoomOut: 'Zoom out',
        zoomIn: 'Zoom in'
      },
      color: {
        title: 'Step 2. Chose your color circle',
        select: 'Choose a color'
      },
      review: {
        title: 'Step 3. Update your avatar',
        download: 'Download your avatar'
      },
      instructions: {
        title_vox: 'Vox',
        title_linkedin: 'LinkedIn',
        title_outlook_mac: 'Outlook (Mac)',
        title_outlook_windows: 'Outlook (Win)',
        title_outlook_webmail: 'Webmail',
        vox: '\n          <p>1. Go to <a href="https://vox.publicis.sapient.com/news" target="blank">Vox</a></p>\n          <p>2. Click on the <span>avatar</span> at the top right</p>\n          <p>3. Click on <span>Edit profile</span></p>\n          <p>4. Go to Avatar\'s part</p>\n          <p>5. Click on <span>Add another avatar</span> \u203A Choose your previously downloaded avatar \u203A Upload and continue</p>\n          <p>6. Click on <span>crop photo</span></p>\n          <p>Your new avatar has been uploaded!</p>\n        ',
        linkedin: '\n          <p>1. Go to <a href="https://www.linkedin.com/feed/" target="blank">LinkedIn</a></p>\n          <p>2. Go to your <span>profile</span></p>\n          <p>3. Click on your <span>image</span></p>\n          <p>4. Click on <span>Change photo / Upload photo</span></p>\n          <p>5. Choose your avatar (that you previously downloaded below) "avatar_linkedin"</p>\n          <p>6. Decrease the zoom to the minimum (1) then increase the zoom slider to 1.1. Your color circle will go beyond the LinkedIn display. (see image below)</p>\n          <center><img src="static/img/capture_linkedin.jpg" alt=""></center>\n          <p>7. Save</p>\n        ',
        outlook_mac: '\n          <p>1. Go to your <a href="https://outlook.office.com/" target="blank">webmail</a></p>\n          <p>2. Click on your <span>avatar</span> at the top right</p>\n          <p>3. Once on your profile, click on the <span>camera</span> near your image \u203A <span>Upload a new image</span></p>\n          <p>4. Choose your avatar (that you previously downloaded below)</p>\n          <p>5. Replace your image</p>\n          <p>6. Click on <span>Set as profile picture</span></p>\n        ',
        outlook_windows: '\n          <p>1. Go to <span>Outlook</span></p>\n          <p>2. Click on <span>Files \u203A Information \u203A Account settings \u203A Edit</span></p>\n          <p>3. You are redirected to the webmail</p>\n          <p>4. Click on <span>Upload a photo</span> and choose your avatar (that you previously downloaded below)</p>\n          <p>5. Click on <span>Save</span></p>\n          <p>Your avatar is now uploaded and will automatically be added to <span>Skype</span> and <span>Outlook</span></p>\n        ',
        outlook_webmail: '\n          <p>1. Go to your <a href="https://outlook.office.com/" target="blank">webmail</a></p>\n          <p>2. Click on your <span>avatar</span> at the top right</p>\n          <p>3. Once on your profile, click on the <span>camera</span> near your image \u203A <span>Upload a new image</span></p>\n          <p>4. Click on <span>Upload a photo</span> and choose your avatar (that you previously downloaded below)</p>\n          <p>5. Click on <span>Save</span></p>\n          <p>Your avatar is now uploaded and will automatically be added to <span>Skype</span> and <span>Outlook</span></p>\n        '
      }
    }
  },
  fr: {
    title_email: 'Personnalisez votre signature mail&nbsp;!',
    title_avatar: 'Obtenez votre avatar personnalisé&nbsp;!',
    topMentions: 'Obtenez votre signature mail aux couleurs de Publicis Sapient en moins d’une minute.',
    buttonIntegrate: 'Intégrer votre signature',
    copiedClipboard: 'C\'est copié !',
    installation: 'Intégration de votre signature',
    buttonCopySignature: 'Copier la signature',
    buttonBack: 'Retour',
    titleFollowInstructions: 'Suivez le pas à pas',
    errorTitle: 'Oups',
    popinClose: 'Fermer',
    mail: {
      title: 'Personnalisez votre signature mail !',
      object: 'Ma signature de mail',
      to: 'À :',
      recipient: 'ALL@publicissapient.com',
      courtesy: 'Hello l\’agence ! Ce petit mail pour vous montrer à quoi ressemblera votre nouvelle signature Publicis Sapient ! Pas mal, non ?\nÀ vous de jouer maintenant ;)',
      mobileLetter: 'M',
      phoneLetter: 'T',
      pronouns: 'Pronoms',
      donate_ukraine: '<a href="https://helping-our-ukraine-team-as-one.iraiser.eu/b/my-donation?cid=1&_cv=1" style="padding-top: 10px; color: #666666; text-decoration: none;font-size: 10px; font-family: arial, helvetica; text-decoration: underline;  line-height: 14px;"  target="_blank"\n      aria-description="Contribuez \xE0 la lev\xE9e de fonds du Groupe Publicis et venez en aide \xE0 notre \xE9quipe en Ukraine.">\n      Contribuez \xE0 la lev\xE9e de fonds du Groupe Publicis <br />et venez en aide \xE0 notre \xE9quipe en Ukraine.</a>'
    },
    tabs: {
      email: 'Créer votre signature',
      avatar: 'Créer votre avatar'
    },
    form: {
      name: 'Prénom',
      name_required: 'Le prénom est requis',
      lastname: 'Nom',
      lastname_required: 'Le nom de famille est requis',
      job: 'Fonction',
      job_required: 'La fonction est requise',
      pronouns: 'Pronoms (optionnel)',
      pronounsList: ['Il', 'Elle', 'Iel', 'Yel', 'Ille', 'El', 'Ul', 'Ol', 'Yol', 'Ael', 'Im', 'Em'],
      pronounsPopin: {
        title: 'Inclure un pronom:',
        text: 'Publicis Sapient représente un ensemble diversifié d\'identités et d\'expressions de genre. Si vous souhaitez vous assurer que les pronoms sont corrects ou si vous manifestez votre soutien à l\'inclusion du genre, incluez le vôtre ici.'
      },
      pslogo: 'Logo',
      pslogoList: {
        PS_Brand: 'PS Brand',
        PS_Pride: 'PS Pride'
      },
      office: 'Locaux',
      office_required: 'Le bureau est requis',
      mobile: 'Portable',
      phone: 'Fixe',
      accolades: 'Choisissez des accolades (optionnel)',
      accoladesList: {
        consulting_reports_top_50_consulting_firms: '2024 Consulting Report\'s Top 50 Consulting Firms',
        forbes_worlds_best_management_consulting_firms: '2024 Forbes World\'s Best Management Consulting Firms',
        HFS_generative_enterprise_services_market_leader_2023: 'HFS Generative Enterprise Services Market Leader, 2023',
        idc_marketScape_for_worldwide_experience_design_2023_24: 'IDC MarketScape for Worldwide Experience Design, 2023-24',
        e_footprint: 'e-footprint',
        google_cloud_partner_of_the_year_2024: 'Google Cloud Partner of the Year 2024',
        VivaTech_2024: 'VivaTech 2024',
        business_disability_forum_member: 'Business Disability Forum Member',
        guide_to_next: 'Guide to Next',
        Consultancy_uk_Top_Consulting_Firms_in_UK_2023: 'Consultancy.uk - Top Consulting Firms in UK 2023',
        consulting_report_top_consulting_firm_2023: 'Consulting Report – Top Consulting Firm 2023',
        carbon_markets: 'Carbon Markets',
        get_ahead_cp: 'Get Ahead - CP',
        seize_the_space_t_h: 'Seize the Space - T&H',
        vault_emea: 'Vault Best Consulting Firms – EMEA',
        vault_north_america: 'Vault Best Consulting Firms – North America',
        vault_apac: 'Vault Best Consulting Firms – APAC',
        workingwithcancer: '#workingwithcancer',
        great_place_to_work_germany: 'Great Place to Work - Germany',
        great_place_to_work_us: 'Great Place to Work - US',
        iDBT: 'iDBT',
        consulting_magazine_best_firms: 'Consulting Magazine Best Firms',
        school_of_next: 'School of Next',
        forbes_best_consulting_firms: 'Forbes Best Consulting Firms',
        egalite: 'ÉGALITÉ',
        shopper_first_retail: 'Shopper First Retail',
        uk_financial_times: 'UK Financial Times',
        human_rights_campaign: 'Human Rights Campaign',
        energy_tech_awards: 'EnergyTech Awards',
        tech_women: 'We Are Tech Women',
        gptw_germany: 'Great Place to Work (Germany), 2019-20',
        certified_great_place: 'Great Place to Work (India), 2019-20',
        the_how_channel: 'The HOW Channel',
        enable: 'enABLE',
        gartner_peer_insights: 'Gartner Peer Insights',
        idc_marketscape_2: 'IDC MarketScape',
        gartner_topscorercx: 'Gartner Top Scorer',
        gartner_magic_quadrant: 'Gartner Magic Quadrant',
        vault_top_ranked_internship_program_2025: 'Vault Top Ranked Internship Program, 2025',
        vault_top_ranked_internship_program_lgbtq_2025: 'Vault Top Ranked Internship Program for LGBTQ+ Individuals, 2025',
        VivaTech_2025: 'VivaTech 2025',
        none: 'Aucune'
      },
      mentions: 'Pas d’inquiétude, vos données personnelles ne seront pas enregistrées.',
      donate: 'Afin de venir en aide \xE0 nos coll\xE8gues en Ukraine,<br />veuillez recopier ce message.'
    },
    instructions: {
      title_outlook_mac: 'Outlook Mac',
      title_outlook_windows: 'Outlook Windows',
      title_webmail: 'Webmail',
      outlook_mac: '\n      <p>1. Cliquez sur <span>Copier la signature</span> ci-dessous</p>\n      <p>2. Dans la barre de menu, acce\u0301dez a\u0300 <span>Outlook \u203A Pre\u0301fe\u0301rences</span> puis cliquez sur <span>Signatures</span></p>\n      <p>3. Cliquez sur le signe <span>[+]</span> et entrez un nom pour votre nouvelle signature</p>\n      <p>4. Dans l\'encadre\u0301 <span>Principal</span>, collez la signature (Cmd + V)<br>\n      Sur Outlook 2016, veillez a\u0300 se\u0301lectionner la premie\u0300re option de collage <span>Conserver la mise en forme de la source</span></p>\n      <p>5. <span>Enregistrez</span> puis se\u0301lectionnez la signature que vous venez de cre\u0301er dans les 2 menus de\u0301roulants (<span>Nouveaux messages</span> et <span>Re\u0301ponses/transferts</span>)</p>\n      <img src="static/img/options-collage-fr.jpg">\n      ',
      outlook_windows: '\n      <p>1. Cliquez sur <span>Copier la signature</span> ci-dessous</p>\n      <p>2a. Pour les anciennes versions d\'Outlook\xA0: <span>Acc\xE9dez \xE0 Fichier\xA0>\xA0Options\xA0>\xA0Courrier</span>. Dans la section <span>R\xE9diger un message</span>, cliquez sur <span>Signatures</span></p>\n      <p>2b. Pour les versions plus r\xE9centes d\'Outlook\xA0: <span>Acc\xE9dez \xE0 Fichier\xA0>\xA0Param\xE8tres\xA0>\xA0Comptes\xA0>\xA0Signatures</span></p>\n      <p>3. Cliquez sur <span>Nouveau</span>\xA0et donnez un nom \xE0 votre nouvelle signature</p>\n      <p>4. Dans l\u2019encadr\xE9 <span>Modifier la signature</span>, collez votre signature (Ctrl + V)</p>\n      <p>5. Sur la droite, sous\xA0<span>Choisir une signature par d\xE9faut</span>, s\xE9lectionnez la signature que vous venez de cr\xE9er</p>\n      <p>6. S\xE9lectionnez la signature que vous venez de cr\xE9er dans les 2 menus d\xE9roulants\xA0(<span>Nouveaux messages</span>\xA0et\xA0<span>R\xE9ponses/transferts</span>)</p>\n      ',
      webmail: '\n      <p>1. Cliquez sur <span>Copier la signature</span> ci-dessous</p>\n      <p>2. Ouvrez le menu <span>Parame\u0300tres</span> en cliquant sur l\'ico\u0302ne en haut a\u0300 droite et tapez <span>"Signature \xE9lectronique"</span> dans la barre de recherche</p>\n      <p>3. Collez la signature (Ctrl + V) dans l\'encadre\u0301 <span>Signature de message e\u0301lectronique</span></p>\n      <p>4. Cochez <span>Ajouter automatiquement ma signature aux messages envoye\u0301s</span></p>\n      '
    },
    avatar: {
      topMentions: 'Créez en quelques clics votre photo de profil aux couleurs de Publicis Sapient.',
      photo: {
        title: 'Étape 1. Téléchargez votre photo',
        titleUploaded: 'Étape 1. Prévisualisation de l\'avatar',
        upload: 'Sélectionnez une photo',
        select: 'Sélectionnez une photo depuis votre ordinateur (formats acceptés : JPG, PNG, GIF, Bitmap)',
        recommend: 'Les dimensions recommandées pour votre image d\'avatar:',
        size: 'Taille minimale de 200 pixels par 200 pixels.',
        adjust: 'Vous pourrez éditer pour ajuster l\'image en agrandissant ou en réduisant la taille.',
        change: 'Changer la photo',
        zoomOut: 'Zoom arrière',
        zoomIn: 'Zoom avant'
      },
      color: {
        title: 'Étape 2. Choisissez la couleur de votre anneau',
        select: 'Sélectionnez une couleur'
      },
      review: {
        title: 'Étape 3. Mettez à jour votre avatar dans vos profils',
        download: 'Télécharger votre avatar'
      },
      instructions: {
        title_vox: 'Vox',
        title_linkedin: 'LinkedIn',
        title_outlook_mac: 'Outlook (Mac)',
        title_outlook_windows: 'Outlook (Win)',
        title_outlook_webmail: 'Webmail',
        vox: '\n          <p>1. Rendez-vous sur <a href="https://vox.publicis.sapient.com/news" target="blank">Vox</a></p>\n          <p>2. Cliquez sur votre <span>avatar</span> en haut \xE0 droite</p>\n          <p>3. Cliquez sur <span>Modifier le profil</span></p>\n          <p>4. Allez dans la partie Avatar</p>\n          <p>5. Cliquez sur <span>Ajouter un nouvel avatar</span> \u203A Choisissez votre avatar (que vous aurez te\u0301le\u0301charge\u0301 au pre\u0301alable) \u203A Te\u0301le\u0301chargez et continuez</p>\n          <p>6. Cliquez sur <span>Recadrer la photo</span></p>\n          <p>C\u0327a y est, votre nouvel avatar est te\u0301le\u0301charge\u0301 !</p>\n        ',
        linkedin: '\n          <p>1. Rendez-vous sur <a href="https://www.linkedin.com/feed/" target="blank">LinkedIn</a></p>\n          <p>2. Allez sur <span>votre profil</span></p>\n          <p>3. Cliquez sur votre photo</p>\n          <p>4. Cliquez sur <span>Modifier la photo / Upload photo</span></p>\n          <p>5. Choisissez votre avatar (que vous aurez te\u0301le\u0301charge\u0301 au pre\u0301alable) "avatar_linkedin"</p>\n          <p>6. Diminuez le zoom au minimum (1) puis augmentez le curseur zoom \xE0 1.1. Ainsi votre cercle de couleur d\xE9passera de l\'affichage LinkedIn. (voir image ci-dessous)</p>\n          <center><img src="static/img/capture_linkedin.jpg" alt=""></center>\n          <p>7. Enregistrez votre nouvelle image</p>\n        ',
        outlook_mac: '\n          <p>1. Rendez-vous sur votre <a href="https://outlook.office.com/" target="blank">webmail</a></p>\n          <p>2. Cliquez sur votre <span>avatar</span> en haut a\u0300 droite</p>\n          <p>3. Une fois sur votre profil, cliquez sur l\'<span>appareil photo</span> pre\u0300s de votre photo \u203A <span>Chargez une nouvelle image</span></p>\n          <p>4. Choisissez votre avatar (que vous aurez te\u0301le\u0301charge\u0301 au pre\u0301alable)</p>\n          <p>5. Recadrez votre nouvelle image</p>\n          <p>6. Cliquez sur <span>De\u0301finir comme photo de profil</span></p>\n        ',
        outlook_windows: '\n          <p>1. Rendez-vous sur <span>Outlook</span></p>\n          <p>2. Cliquez sur <span>Fichier \u203A Informations \u203A Parame\u0300tre du compte \u203A Modifier</span></p>\n          <p>3. Vous \xEAtes redirig\xE9 sur le webmail</p>\n          <p>4. Cliquez sur <span>Charger une photo</span> et choisissez votre avatar (que vous aurez te\u0301le\u0301charge\u0301 au pre\u0301alable)</p>\n          <p>5. Cliquez sur <span>Enregistrer</span></p>\n          <p>C\u0327a y est, votre nouvel avatar est te\u0301le\u0301charge\u0301 et se chargera automatiquement sur <span>Skype</span> et <span>Outlook</span> !</p>\n        ',
        outlook_webmail: '\n          <p>1. Rendez-vous sur votre <a href="https://outlook.office.com/" target="blank">webmail</a></p>\n          <p>2. Cliquez sur votre <span>avatar</span> en haut \xE0 droite</p>\n          <p>3. Une fois sur votre profil, cliquez sur l\'<span>appareil photo</span> pr\xE8s de votre photo \u203A <span>Chargez une nouvelle image</span></p>\n          <p>4. Cliquez sur <span>Charger une photo</span> et choisissez votre avatar (que vous aurez te\u0301le\u0301charge\u0301 au pre\u0301alable)</p>\n          <p>5. Cliquez sur <span>Enregistrer</span></p>\n          <p>C\u0327a y est, votre nouvel avatar est te\u0301le\u0301charge\u0301 et se chargera automatiquement sur <span>Skype</span> et <span>Outlook</span> !</p>\n        '
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (labels);

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var uuid = __webpack_require__(534);

var Utils = {
  generateTag: function generateTag(ec, ea) {
    var datas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var ga_generate = document.querySelector('.ga_generate');
    ga_generate.innerHTML = this.getTag(ec, ea, datas);
  },

  getTag: function getTag(ec, ea, datas) {
    var preventLoad = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var uuid4 = Utils.getUuid();

    var label = datas ? '&el=' + datas : '';
    var url = 'https://www.google-analytics.com/collect?v=1&tid=UA-114380286-2&t=event&ec=' + ec + '&ea=' + ea + label + '&cid=' + uuid4;
    return '<img border="0" width="0" height="0" src="' + url + '"/>';
  },

  formStorage: function formStorage() {
    var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'save';
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var STORAGE_KEY = 'publicis-signature-v2';
    return this.localStorage(method, data, STORAGE_KEY);
  },
  uuidStorage: function uuidStorage() {
    var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'save';
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var STORAGE_KEY = 'publicis-signature-uuid-v1';
    return this.localStorage(method, data, STORAGE_KEY);
  },
  getUuid: function getUuid() {
    var uuid4 = uuid();
    if (!Utils.uuidStorage('fetch')) {
      Utils.uuidStorage('save', uuid4);
      return uuid4;
    }
    return Utils.uuidStorage('fetch');
  },
  localStorage: function (_localStorage) {
    function localStorage() {
      return _localStorage.apply(this, arguments);
    }

    localStorage.toString = function () {
      return _localStorage.toString();
    };

    return localStorage;
  }(function () {
    var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'save';
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var storageKey = arguments[2];

    switch (method) {
      case 'fetch':
        try {
          return JSON.parse(localStorage.getItem(storageKey) || 0);
        } catch (e) {
          return {};
        }
        break;
      case 'save':
        try {
          localStorage.setItem(storageKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        } catch (e) {
          return {};
        }
        break;
    }
  }),

  formatPhone: function formatPhone(phone, indicatif) {
    var numbers = phone.replace(/\D/g, '');
    var formated = '';
    var char = { 0: indicatif + ' (', 1: ')' };
    for (var i = 0; i < numbers.length; i++) {
      formated += (char[i] || (!char[i] && i % 2 === 0 ? ' ' : '')) + numbers[i];
    }
    return formated;
  },

  findGetParameter: function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    window.location.search.substr(1).split("&").forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Utils);

/***/ })

},[204]);


// WEBPACK FOOTER //
// static/js/app.js